// THIS FILE IS GENERATED - DO NOT EDIT
// To re-generate run ./scripts/generate_emoji_data.js
export default {
  regional_indicator_a: ['🇦'],
  regional_indicator_b: ['🇧'],
  regional_indicator_c: ['🇨'],
  regional_indicator_d: ['🇩'],
  regional_indicator_e: ['🇪'],
  regional_indicator_f: ['🇫'],
  regional_indicator_g: ['🇬'],
  regional_indicator_h: ['🇭'],
  regional_indicator_i: ['🇮'],
  regional_indicator_j: ['🇯'],
  regional_indicator_k: ['🇰'],
  regional_indicator_l: ['🇱'],
  regional_indicator_m: ['🇲'],
  regional_indicator_n: ['🇳'],
  regional_indicator_o: ['🇴'],
  regional_indicator_p: ['🇵'],
  regional_indicator_q: ['🇶'],
  regional_indicator_r: ['🇷'],
  regional_indicator_s: ['🇸'],
  regional_indicator_t: ['🇹'],
  regional_indicator_u: ['🇺'],
  regional_indicator_v: ['🇻'],
  regional_indicator_w: ['🇼'],
  regional_indicator_x: ['🇽'],
  regional_indicator_y: ['🇾'],
  regional_indicator_z: ['🇿'],
  grinning_face: ['😀', 'grinning', 0],
  grinning_face_with_big_eyes: ['😃', 'smiley', 0],
  grinning_face_with_smiling_eyes: ['😄', 'grinning_face_with_closed_eyes smile', ':D :-D', 0],
  beaming_face_with_smiling_eyes: ['😁', 'beaming_face grin', 0],
  grinning_squinting_face: ['😆', 'laughing lol satisfied squinting_face', 'x-) X-)', 0],
  grinning_face_with_sweat: ['😅', 'sweat_smile', ',:) ,:-)', 0],
  rolling_on_the_floor_laughing: ['🤣', 'rofl', 0],
  face_with_tears_of_joy: ['😂', 'joy lmao tears_of_joy', ":') :'-) :,) :,-) :'D :'-D :,D :,-D", 0],
  slightly_smiling_face: ['🙂', '', ':) :-)', 0],
  upside_down_face: ['🙃', 0],
  melting_face: ['🫠', 'melt', 0],
  winking_face: ['😉', 'wink', ';) ;-)', 0],
  smiling_face_with_smiling_eyes: ['😊', 'blush smiling_face_with_closed_eyes', ':") :-")', 0],
  smiling_face_with_halo: ['😇', 'halo innocent', 'o:) O:) o:-) O:-) 0:) 0:-)', 0],
  smiling_face_with_hearts: ['🥰', 'smiling_face_with_3_hearts smiling_face_with_three_hearts', 0],
  smiling_face_with_heart_eyes: ['😍', 'heart_eyes', 0],
  star_struck: ['🤩', 0],
  face_blowing_a_kiss: ['😘', 'blowing_a_kiss kissing_heart', 0],
  kissing_face: ['😗', 'kissing', ':* :-*', 0],
  smiling_face: ['☺', 'relaxed', 0],
  kissing_face_with_closed_eyes: ['😚', 'kissing_closed_eyes', 0],
  kissing_face_with_smiling_eyes: ['😙', 'kissing_smiling_eyes', 0],
  smiling_face_with_tear: ['🥲', 0],
  face_savoring_food: ['😋', 'savoring_food yum', 0],
  face_with_tongue: ['😛', 'stuck_out_tongue', ':P :-P', 0],
  winking_face_with_tongue: ['😜', 'stuck_out_tongue_winking_eye', 0],
  zany_face: ['🤪', 'zany', 0],
  squinting_face_with_tongue: ['😝', 'stuck_out_tongue_closed_eyes', 0],
  money_mouth_face: ['🤑', 0],
  smiling_face_with_open_hands: ['🤗', 'hug hugging hugging_face hugs', 0],
  face_with_hand_over_mouth: ['🤭', 'hand_over_mouth', 0],
  face_with_open_eyes_and_hand_over_mouth: ['🫢', 'face_with_open_eyes_hand_over_mouth gasp', 0],
  face_with_peeking_eye: ['🫣', 'peek', 0],
  shushing_face: ['🤫', 'shush', 0],
  thinking_face: ['🤔', 'thinking wtf', 0],
  saluting_face: ['🫡', 'salute', 0],
  zipper_mouth_face: ['🤐', 'zipper_mouth', 0],
  face_with_raised_eyebrow: ['🤨', 'raised_eyebrow', 0],
  neutral_face: ['😐', 'neutral', ':| :-|', 0],
  expressionless_face: ['😑', 'expressionless', 0],
  face_without_mouth: ['😶', 'no_mouth', 0],
  dotted_line_face: ['🫥', 0],
  face_in_clouds: ['😶‍🌫️', 'in_clouds', 0],
  smirking_face: ['😏', 'smirk smirking', 0],
  unamused_face: ['😒', 'unamused', ':s :-S :z :-Z :$ :-$', 0],
  face_with_rolling_eyes: ['🙄', 'rolling_eyes roll_eyes', 0],
  grimacing_face: ['😬', 'grimacing', 0],
  face_exhaling: ['😮‍💨', 'exhale exhaling', 0],
  lying_face: ['🤥', 'lying', 0],
  shaking_face: ['🫨', 'shaking', 0],
  head_shaking_horizontally: ['🙂‍↔️', 0],
  head_shaking_vertically: ['🙂‍↕️', 0],
  relieved_face: ['😌', 'relieved', 0],
  pensive_face: ['😔', 'pensive', 0],
  sleepy_face: ['😪', 'sleepy', 0],
  drooling_face: ['🤤', 'drooling', 0],
  sleeping_face: ['😴', 'sleeping', 0],
  face_with_bags_under_eyes: ['🫩', 'face_with_eye_bags', 0],
  face_with_medical_mask: ['😷', 'mask medical_mask', 0],
  face_with_thermometer: ['🤒', 0],
  face_with_head_bandage: ['🤕', 0],
  nauseated_face: ['🤢', 'nauseated', 0],
  face_vomiting: ['🤮', 'vomiting vomiting_face', 0],
  sneezing_face: ['🤧', 'sneezing', 0],
  hot_face: ['🥵', 'hot', 0],
  cold_face: ['🥶', 'cold', 0],
  woozy_face: ['🥴', 'woozy', 0],
  face_with_crossed_out_eyes: ['😵', 'dizzy_face knocked_out', 0],
  face_with_spiral_eyes: ['😵‍💫', 'dizzy_eyes', 0],
  exploding_head: ['🤯', 0],
  cowboy_hat_face: ['🤠', 'cowboy cowboy_face', 0],
  partying_face: ['🥳', 'hooray partying', 0],
  disguised_face: ['🥸', 'disguised', 0],
  smiling_face_with_sunglasses: ['😎', 'sunglasses_cool too_cool', '8-) B-)', 0],
  nerd_face: ['🤓', 'nerd', 0],
  face_with_monocle: ['🧐', 'monocle_face', 0],
  confused_face: ['😕', 'confused', ':/ :-/', 0],
  face_with_diagonal_mouth: ['🫤', 0],
  worried_face: ['😟', 'worried', 0],
  slightly_frowning_face: ['🙁', 0],
  frowning_face: ['☹', 'white_frowning_face', 0],
  face_with_open_mouth: ['😮', 'open_mouth', ':o :-o :O :-O', 0],
  hushed_face: ['😯', 'hushed', 0],
  astonished_face: ['😲', 'astonished', 0],
  flushed_face: ['😳', 'flushed', 0],
  distorted_face: ['🫪', 0],
  pleading_face: ['🥺', 'pleading', 0],
  face_holding_back_tears: ['🥹', 'watery_eyes', 0],
  frowning_face_with_open_mouth: ['😦', 'frowning frowning_face', ':( :-(', 0],
  anguished_face: ['😧', 'anguished', 0],
  fearful_face: ['😨', 'fearful', 0],
  anxious_face_with_sweat: ['😰', 'anxious anxious_face cold_sweat', 0],
  sad_but_relieved_face: ['😥', 'disappointed_relieved sad_relieved_face', 0],
  crying_face: ['😢', 'cry', ":'( :'-( :,( :,-(", 0],
  loudly_crying_face: ['😭', 'sob', ":,'( :,'-( ;( ;-(", 0],
  face_screaming_in_fear: ['😱', 'scream screaming_in_fear', 0],
  confounded_face: ['😖', 'confounded', 0],
  persevering_face: ['😣', 'persevere', 0],
  disappointed_face: ['😞', 'disappointed', 0],
  downcast_face_with_sweat: ['😓', 'downcast_face sweat', ',:( ,:-(', 0],
  weary_face: ['😩', 'weary', 0],
  tired_face: ['😫', 'tired', 0],
  yawning_face: ['🥱', 'yawn yawning', 0],
  face_with_steam_from_nose: ['😤', 'nose_steam triumph', 0],
  enraged_face: ['😡', 'pout pouting_face rage', ':@ :-@', 0],
  angry_face: ['😠', 'angry', '>:( >:-(', 0],
  face_with_symbols_on_mouth: ['🤬', 'censored cursing_face', 0],
  smiling_face_with_horns: ['😈', 'smiling_imp', ']:) ]:-)', 0],
  angry_face_with_horns: ['👿', 'angry_imp imp', ']:( ]:-(', 0],
  skull: ['💀', 0],
  skull_and_crossbones: ['☠', 0],
  pile_of_poo: ['💩', 'poop shit hankey', 0],
  clown_face: ['🤡', 'clown', 0],
  ogre: ['👹', 'japanese_ogre', 0],
  goblin: ['👺', 'japanese_goblin', 0],
  ghost: ['👻', 0],
  alien: ['👽', 0],
  alien_monster: ['👾', 'space_invader', 0],
  robot: ['🤖', 'robot_face', 0],
  grinning_cat: ['😺', 'smiley_cat', 0],
  grinning_cat_with_smiling_eyes: ['😸', 'grinning_cat_with_closed_eyes smile_cat', 0],
  cat_with_tears_of_joy: ['😹', 'joy_cat tears_of_joy_cat', 0],
  smiling_cat_with_heart_eyes: ['😻', 'heart_eyes_cat', 0],
  cat_with_wry_smile: ['😼', 'smirk_cat wry_smile_cat', 0],
  kissing_cat: ['😽', 0],
  weary_cat: ['🙀', 'scream_cat', 0],
  crying_cat: ['😿', 'crying_cat_face', 0],
  pouting_cat: ['😾', 0],
  see_no_evil_monkey: ['🙈', 'see_no_evil', 0],
  hear_no_evil_monkey: ['🙉', 'hear_no_evil', 0],
  speak_no_evil_monkey: ['🙊', 'speak_no_evil', 0],
  love_letter: ['💌', 0],
  heart_with_arrow: ['💘', 'cupid', 0],
  heart_with_ribbon: ['💝', 'gift_heart', 0],
  sparkling_heart: ['💖', 0],
  growing_heart: ['💗', 'heartpulse', 0],
  beating_heart: ['💓', 'heartbeat', 0],
  revolving_hearts: ['💞', 0],
  two_hearts: ['💕', 0],
  heart_decoration: ['💟', 0],
  heart_exclamation: ['❣', 'heavy_heart_exclamation', 0],
  broken_heart: ['💔', '', '</3 <\\3', 0],
  heart_on_fire: ['❤️‍🔥', 0],
  mending_heart: ['❤️‍🩹', 0],
  red_heart: ['❤', 'heart', '<3', 0],
  pink_heart: ['🩷', 0],
  orange_heart: ['🧡', 0],
  yellow_heart: ['💛', 0],
  green_heart: ['💚', 0],
  blue_heart: ['💙', 0],
  light_blue_heart: ['🩵', 0],
  purple_heart: ['💜', 0],
  brown_heart: ['🤎', 0],
  black_heart: ['🖤', 0],
  grey_heart: ['🩶', 'gray_heart', 0],
  white_heart: ['🤍', 0],
  kiss_mark: ['💋', 'kiss', 0],
  hundred_points: ['💯', '100', 0],
  anger_symbol: ['💢', 'anger', 0],
  fight_cloud: ['🫯', 0],
  collision: ['💥', 'boom', 0],
  dizzy: ['💫', 0],
  sweat_droplets: ['💦', 'sweat_drops', 0],
  dashing_away: ['💨', 'dash', 0],
  hole: ['🕳', 0],
  speech_balloon: ['💬', 0],
  eye_in_speech_bubble: ['👁️‍🗨️', 'eye_speech_bubble', 0],
  left_speech_bubble: ['🗨', 0],
  right_anger_bubble: ['🗯', 0],
  thought_balloon: ['💭', 0],
  zzz: ['💤', 0],
  waving_hand: ['👋', 'wave', 1],
  raised_back_of_hand: ['🤚', 1],
  hand_with_fingers_splayed: ['🖐', 'raised_hand_with_fingers_splayed', 1],
  raised_hand: ['✋', 'high_five hand', 1],
  vulcan_salute: ['🖖', 'vulcan', 1],
  rightwards_hand: ['🫱', 1],
  leftwards_hand: ['🫲', 1],
  palm_down_hand: ['🫳', 'palm_down', 1],
  palm_up_hand: ['🫴', 'palm_up', 1],
  leftwards_pushing_hand: ['🫷', 1],
  rightwards_pushing_hand: ['🫸', 1],
  ok_hand: ['👌', 1],
  pinched_fingers: ['🤌', 'pinch', 1],
  pinching_hand: ['🤏', 1],
  victory_hand: ['✌', 'v victory', 1],
  crossed_fingers: ['🤞', 'fingers_crossed', 1],
  hand_with_index_finger_and_thumb_crossed: ['🫰', 1],
  love_you_gesture: ['🤟', 1],
  sign_of_the_horns: ['🤘', 'metal', 1],
  call_me_hand: ['🤙', 1],
  backhand_index_pointing_left: ['👈', 'point_left', 1],
  backhand_index_pointing_right: ['👉', 'point_right', 1],
  backhand_index_pointing_up: ['👆', 'point_up', 1],
  middle_finger: ['🖕', 'fu', 1],
  backhand_index_pointing_down: ['👇', 'point_down', 1],
  index_pointing_up: ['☝', 'point_up_2', 1],
  index_pointing_at_the_viewer: ['🫵', 'point_forward', 1],
  thumbs_up: ['👍', '+1 thumbsup yes', 1],
  thumbs_down: ['👎', '-1 no thumbsdown', 1],
  raised_fist: ['✊', 'fist fist_raised', 1],
  oncoming_fist: ['👊', 'punch fist_oncoming facepunch', 1],
  left_facing_fist: ['🤛', 'fist_left', 1],
  right_facing_fist: ['🤜', 'fist_right', 1],
  clapping_hands: ['👏', 'clap', 1],
  raising_hands: ['🙌', 'raised_hands', 1],
  heart_hands: ['🫶', 1],
  open_hands: ['👐', 1],
  palms_up_together: ['🤲', 1],
  handshake: ['🤝', 1],
  folded_hands: ['🙏', 'pray', 1],
  writing_hand: ['✍', 1],
  nail_polish: ['💅', 'nail_care', 1],
  selfie: ['🤳', 1],
  flexed_biceps: ['💪', 'muscle right_bicep', 1],
  mechanical_arm: ['🦾', 1],
  mechanical_leg: ['🦿', 1],
  leg: ['🦵', 1],
  foot: ['🦶', 1],
  ear: ['👂', 1],
  ear_with_hearing_aid: ['🦻', 'hearing_aid', 1],
  nose: ['👃', 1],
  brain: ['🧠', 1],
  anatomical_heart: ['🫀', 1],
  lungs: ['🫁', 1],
  tooth: ['🦷', 1],
  bone: ['🦴', 1],
  eyes: ['👀', 1],
  eye: ['👁', 1],
  tongue: ['👅', 1],
  mouth: ['👄', 'lips', 1],
  biting_lip: ['🫦', 1],
  baby: ['👶', 1],
  child: ['🧒', 1],
  boy: ['👦', 1],
  girl: ['👧', 1],
  person: ['🧑', 'adult', 1],
  person_blond_hair: ['👱', 'blond_haired blond_haired_person', 1],
  man: ['👨', 1],
  person_beard: ['🧔', 'person_bearded bearded_person', 1],
  man_beard: ['🧔‍♂️', 'man_bearded', 1],
  woman_beard: ['🧔‍♀️', 'woman_bearded', 1],
  man_red_hair: ['👨‍🦰', 'man_red_haired red_haired_man', 1],
  man_curly_hair: ['👨‍🦱', 'man_curly_haired curly_haired_man', 1],
  man_white_hair: ['👨‍🦳', 'man_white_haired white_haired_man', 1],
  man_bald: ['👨‍🦲', 'bald_man', 1],
  woman: ['👩', 1],
  woman_red_hair: ['👩‍🦰', 'woman_red_haired red_haired_woman', 1],
  person_red_hair: ['🧑‍🦰', 'red_haired', 1],
  woman_curly_hair: ['👩‍🦱', 'woman_curly_haired curly_haired_woman', 1],
  person_curly_hair: ['🧑‍🦱', 'curly_haired', 1],
  woman_white_hair: ['👩‍🦳', 'woman_white_haired white_haired_woman', 1],
  person_white_hair: ['🧑‍🦳', 'white_haired', 1],
  woman_bald: ['👩‍🦲', 'bald_woman', 1],
  person_bald: ['🧑‍🦲', 'bald', 1],
  woman_blond_hair: ['👱‍♀️', 'woman_blond_haired blond_haired_woman blonde_woman', 1],
  man_blond_hair: ['👱‍♂️', 'man_blond_haired blond_haired_man', 1],
  older_person: ['🧓', 'older_adult', 1],
  old_man: ['👴', 'older_man', 1],
  old_woman: ['👵', 'older_woman', 1],
  person_frowning: ['🙍', 'frowning_person', 1],
  man_frowning: ['🙍‍♂️', 'frowning_man', 1],
  woman_frowning: ['🙍‍♀️', 'frowning_woman', 1],
  person_pouting: ['🙎', 'pouting', 1],
  man_pouting: ['🙎‍♂️', 'pouting_man', 1],
  woman_pouting: ['🙎‍♀️', 'pouting_woman', 1],
  person_gesturing_no: ['🙅', 'no_good', 1],
  man_gesturing_no: ['🙅‍♂️', 'no_good_man ng_man', 1],
  woman_gesturing_no: ['🙅‍♀️', 'no_good_woman ng_woman', 1],
  person_gesturing_ok: ['🙆', 'all_good ok_person ok_woman', 1],
  man_gesturing_ok: ['🙆‍♂️', 'ok_man', 1],
  woman_gesturing_ok: ['🙆‍♀️', 1],
  person_tipping_hand: ['💁', 'tipping_hand_person information_desk_person', 1],
  man_tipping_hand: ['💁‍♂️', 'tipping_hand_man sassy_man', 1],
  woman_tipping_hand: ['💁‍♀️', 'tipping_hand_woman sassy_woman', 1],
  person_raising_hand: ['🙋', 'raising_hand', 1],
  man_raising_hand: ['🙋‍♂️', 'raising_hand_man', 1],
  woman_raising_hand: ['🙋‍♀️', 'raising_hand_woman', 1],
  deaf_person: ['🧏', 1],
  deaf_man: ['🧏‍♂️', 1],
  deaf_woman: ['🧏‍♀️', 1],
  person_bowing: ['🙇', 'bow', 1],
  man_bowing: ['🙇‍♂️', 'bowing_man', 1],
  woman_bowing: ['🙇‍♀️', 'bowing_woman', 1],
  person_facepalming: ['🤦', 'facepalm', 1],
  man_facepalming: ['🤦‍♂️', 1],
  woman_facepalming: ['🤦‍♀️', 1],
  person_shrugging: ['🤷', 'shrug', 1],
  man_shrugging: ['🤷‍♂️', 1],
  woman_shrugging: ['🤷‍♀️', 1],
  health_worker: ['🧑‍⚕️', 1],
  man_health_worker: ['👨‍⚕️', 1],
  woman_health_worker: ['👩‍⚕️', 1],
  student: ['🧑‍🎓', 1],
  man_student: ['👨‍🎓', 1],
  woman_student: ['👩‍🎓', 1],
  teacher: ['🧑‍🏫', 1],
  man_teacher: ['👨‍🏫', 1],
  woman_teacher: ['👩‍🏫', 1],
  judge: ['🧑‍⚖️', 1],
  man_judge: ['👨‍⚖️', 1],
  woman_judge: ['👩‍⚖️', 1],
  farmer: ['🧑‍🌾', 1],
  man_farmer: ['👨‍🌾', 1],
  woman_farmer: ['👩‍🌾', 1],
  cook: ['🧑‍🍳', 1],
  man_cook: ['👨‍🍳', 1],
  woman_cook: ['👩‍🍳', 1],
  mechanic: ['🧑‍🔧', 1],
  man_mechanic: ['👨‍🔧', 1],
  woman_mechanic: ['👩‍🔧', 1],
  factory_worker: ['🧑‍🏭', 1],
  man_factory_worker: ['👨‍🏭', 1],
  woman_factory_worker: ['👩‍🏭', 1],
  office_worker: ['🧑‍💼', 1],
  man_office_worker: ['👨‍💼', 1],
  woman_office_worker: ['👩‍💼', 1],
  scientist: ['🧑‍🔬', 1],
  man_scientist: ['👨‍🔬', 1],
  woman_scientist: ['👩‍🔬', 1],
  technologist: ['🧑‍💻', 1],
  man_technologist: ['👨‍💻', 1],
  woman_technologist: ['👩‍💻', 1],
  singer: ['🧑‍🎤', 1],
  man_singer: ['👨‍🎤', 1],
  woman_singer: ['👩‍🎤', 1],
  artist: ['🧑‍🎨', 1],
  man_artist: ['👨‍🎨', 1],
  woman_artist: ['👩‍🎨', 1],
  pilot: ['🧑‍✈️', 1],
  man_pilot: ['👨‍✈️', 1],
  woman_pilot: ['👩‍✈️', 1],
  astronaut: ['🧑‍🚀', 1],
  man_astronaut: ['👨‍🚀', 1],
  woman_astronaut: ['👩‍🚀', 1],
  firefighter: ['🧑‍🚒', 1],
  man_firefighter: ['👨‍🚒', 1],
  woman_firefighter: ['👩‍🚒', 1],
  police_officer: ['👮', 'cop', 1],
  man_police_officer: ['👮‍♂️', 'policeman', 1],
  woman_police_officer: ['👮‍♀️', 'policewoman', 1],
  detective: ['🕵', 1],
  man_detective: ['🕵️‍♂️', 'male_detective', 1],
  woman_detective: ['🕵️‍♀️', 'female_detective', 1],
  guard: ['💂', 'guardsman', 1],
  man_guard: ['💂‍♂️', 1],
  woman_guard: ['💂‍♀️', 'guardswoman', 1],
  ninja: ['🥷', 1],
  construction_worker: ['👷', 1],
  man_construction_worker: ['👷‍♂️', 'construction_worker_man', 1],
  woman_construction_worker: ['👷‍♀️', 'construction_worker_woman', 1],
  person_with_crown: ['🫅', 'royalty', 1],
  prince: ['🤴', 1],
  princess: ['👸', 1],
  person_wearing_turban: ['👳', 'person_with_turban man_with_turban', 1],
  man_wearing_turban: ['👳‍♂️', 1],
  woman_wearing_turban: ['👳‍♀️', 'woman_with_turban', 1],
  person_with_skullcap: ['👲', 'man_with_gua_pi_mao', 1],
  woman_with_headscarf: ['🧕', 1],
  person_in_tuxedo: ['🤵', 1],
  man_in_tuxedo: ['🤵‍♂️', 1],
  woman_in_tuxedo: ['🤵‍♀️', 1],
  person_with_veil: ['👰', 1],
  man_with_veil: ['👰‍♂️', 1],
  woman_with_veil: ['👰‍♀️', 'bride_with_veil', 1],
  pregnant_woman: ['🤰', 1],
  pregnant_man: ['🫃', 1],
  pregnant_person: ['🫄', 1],
  breast_feeding: ['🤱', 1],
  woman_feeding_baby: ['👩‍🍼', 1],
  man_feeding_baby: ['👨‍🍼', 1],
  person_feeding_baby: ['🧑‍🍼', 1],
  baby_angel: ['👼', 'angel', 1],
  santa_claus: ['🎅', 'santa', 1],
  mrs_claus: ['🤶', 1],
  mx_claus: ['🧑‍🎄', 1],
  superhero: ['🦸', 1],
  man_superhero: ['🦸‍♂️', 'superhero_man', 1],
  woman_superhero: ['🦸‍♀️', 'superhero_woman', 1],
  supervillain: ['🦹', 1],
  man_supervillain: ['🦹‍♂️', 'supervillain_man', 1],
  woman_supervillain: ['🦹‍♀️', 'supervillain_woman', 1],
  mage: ['🧙', 1],
  man_mage: ['🧙‍♂️', 'mage_man', 1],
  woman_mage: ['🧙‍♀️', 'mage_woman', 1],
  fairy: ['🧚', 1],
  man_fairy: ['🧚‍♂️', 'fairy_man', 1],
  woman_fairy: ['🧚‍♀️', 'fairy_woman', 1],
  vampire: ['🧛', 1],
  man_vampire: ['🧛‍♂️', 'vampire_man', 1],
  woman_vampire: ['🧛‍♀️', 'vampire_woman', 1],
  merperson: ['🧜', 1],
  merman: ['🧜‍♂️', 1],
  mermaid: ['🧜‍♀️', 1],
  elf: ['🧝', 1],
  man_elf: ['🧝‍♂️', 'elf_man', 1],
  woman_elf: ['🧝‍♀️', 'elf_woman', 1],
  genie: ['🧞', 1],
  man_genie: ['🧞‍♂️', 'genie_man', 1],
  woman_genie: ['🧞‍♀️', 'genie_woman', 1],
  zombie: ['🧟', 1],
  man_zombie: ['🧟‍♂️', 'zombie_man', 1],
  woman_zombie: ['🧟‍♀️', 'zombie_woman', 1],
  troll: ['🧌', 1],
  hairy_creature: ['🫈', 1],
  person_getting_massage: ['💆', 'massage', 1],
  man_getting_massage: ['💆‍♂️', 'massage_man', 1],
  woman_getting_massage: ['💆‍♀️', 'massage_woman', 1],
  person_getting_haircut: ['💇', 'haircut', 1],
  man_getting_haircut: ['💇‍♂️', 'haircut_man', 1],
  woman_getting_haircut: ['💇‍♀️', 'haircut_woman', 1],
  person_walking: ['🚶', 'walking', 1],
  man_walking: ['🚶‍♂️', 'walking_man', 1],
  woman_walking: ['🚶‍♀️', 'walking_woman', 1],
  person_walking_facing_right: ['🚶‍➡️', 'person_walking_right', 1],
  woman_walking_facing_right: ['🚶‍♀️‍➡️', 'woman_walking_right', 1],
  man_walking_facing_right: ['🚶‍♂️‍➡️', 'man_walking_right', 1],
  person_standing: ['🧍', 'standing standing_person', 1],
  man_standing: ['🧍‍♂️', 'standing_man', 1],
  woman_standing: ['🧍‍♀️', 'standing_woman', 1],
  person_kneeling: ['🧎', 'kneeling kneeling_person', 1],
  man_kneeling: ['🧎‍♂️', 'kneeling_man', 1],
  woman_kneeling: ['🧎‍♀️', 'kneeling_woman', 1],
  person_kneeling_facing_right: ['🧎‍➡️', 'person_kneeling_right', 1],
  woman_kneeling_facing_right: ['🧎‍♀️‍➡️', 'woman_kneeling_right', 1],
  man_kneeling_facing_right: ['🧎‍♂️‍➡️', 'man_kneeling_right', 1],
  person_with_white_cane: ['🧑‍🦯', 'person_with_probing_cane', 1],
  person_with_white_cane_facing_right: ['🧑‍🦯‍➡️', 'person_with_white_cane_right', 1],
  man_with_white_cane: ['👨‍🦯', 'man_with_probing_cane', 1],
  man_with_white_cane_facing_right: ['👨‍🦯‍➡️', 'man_with_white_cane_right', 1],
  woman_with_white_cane: ['👩‍🦯', 'woman_with_probing_cane', 1],
  woman_with_white_cane_facing_right: ['👩‍🦯‍➡️', 'woman_with_white_cane_right', 1],
  person_in_motorized_wheelchair: ['🧑‍🦼', 1],
  person_in_motorized_wheelchair_facing_right: ['🧑‍🦼‍➡️', 'person_in_motorized_wheelchair_right', 1],
  man_in_motorized_wheelchair: ['👨‍🦼', 1],
  man_in_motorized_wheelchair_facing_right: ['👨‍🦼‍➡️', 'man_in_motorized_wheelchair_right', 1],
  woman_in_motorized_wheelchair: ['👩‍🦼', 1],
  woman_in_motorized_wheelchair_facing_right: ['👩‍🦼‍➡️', 'woman_in_motorized_wheelchair_right', 1],
  person_in_manual_wheelchair: ['🧑‍🦽', 1],
  person_in_manual_wheelchair_facing_right: ['🧑‍🦽‍➡️', 'person_in_manual_wheelchair_right', 1],
  man_in_manual_wheelchair: ['👨‍🦽', 1],
  man_in_manual_wheelchair_facing_right: ['👨‍🦽‍➡️', 'man_in_manual_wheelchair_right', 1],
  woman_in_manual_wheelchair: ['👩‍🦽', 1],
  woman_in_manual_wheelchair_facing_right: ['👩‍🦽‍➡️', 'woman_in_manual_wheelchair_right', 1],
  person_running: ['🏃', 'running runner', 1],
  man_running: ['🏃‍♂️', 'running_man', 1],
  woman_running: ['🏃‍♀️', 'running_woman', 1],
  person_running_facing_right: ['🏃‍➡️', 'person_running_right', 1],
  woman_running_facing_right: ['🏃‍♀️‍➡️', 'woman_running_right', 1],
  man_running_facing_right: ['🏃‍♂️‍➡️', 'man_running_right', 1],
  ballet_dancer: ['🧑‍🩰', 1],
  woman_dancing: ['💃', 'dancer', 1],
  man_dancing: ['🕺', 1],
  person_in_suit_levitating: ['🕴', 'levitate levitating business_suit_levitating', 1],
  people_with_bunny_ears: ['👯', 'dancers people_with_bunny_ears_partying', 1],
  men_with_bunny_ears: ['👯‍♂️', 'men_with_bunny_ears_partying dancing_men', 1],
  women_with_bunny_ears: ['👯‍♀️', 'women_with_bunny_ears_partying dancing_women', 1],
  person_in_steamy_room: ['🧖', 'sauna_person', 1],
  man_in_steamy_room: ['🧖‍♂️', 'sauna_man', 1],
  woman_in_steamy_room: ['🧖‍♀️', 'sauna_woman', 1],
  person_climbing: ['🧗', 'climbing', 1],
  man_climbing: ['🧗‍♂️', 'climbing_man', 1],
  woman_climbing: ['🧗‍♀️', 'climbing_woman', 1],
  person_fencing: ['🤺', 'fencer fencing', 1],
  horse_racing: ['🏇', 1],
  skier: ['⛷', 'person_skiing skiing', 1],
  snowboarder: ['🏂', 'person_snowboarding snowboarding', 1],
  person_golfing: ['🏌', 'golfer golfing', 1],
  man_golfing: ['🏌️‍♂️', 'golfing_man', 1],
  woman_golfing: ['🏌️‍♀️', 'golfing_woman', 1],
  person_surfing: ['🏄', 'surfer surfing', 1],
  man_surfing: ['🏄‍♂️', 'surfing_man', 1],
  woman_surfing: ['🏄‍♀️', 'surfing_woman', 1],
  person_rowing_boat: ['🚣', 'rowboat', 1],
  man_rowing_boat: ['🚣‍♂️', 'rowing_man', 1],
  woman_rowing_boat: ['🚣‍♀️', 'rowing_woman', 1],
  person_swimming: ['🏊', 'swimmer swimming', 1],
  man_swimming: ['🏊‍♂️', 'swimming_man', 1],
  woman_swimming: ['🏊‍♀️', 'swimming_woman', 1],
  person_bouncing_ball: ['⛹', 'bouncing_ball_person', 1],
  man_bouncing_ball: ['⛹️‍♂️', 'bouncing_ball_man basketball_man', 1],
  woman_bouncing_ball: ['⛹️‍♀️', 'bouncing_ball_woman basketball_woman', 1],
  person_lifting_weights: ['🏋', 'weight_lifter weight_lifting', 1],
  man_lifting_weights: ['🏋️‍♂️', 'weight_lifting_man', 1],
  woman_lifting_weights: ['🏋️‍♀️', 'weight_lifting_woman', 1],
  person_biking: ['🚴', 'bicyclist biking', 1],
  man_biking: ['🚴‍♂️', 'biking_man', 1],
  woman_biking: ['🚴‍♀️', 'biking_woman', 1],
  person_mountain_biking: ['🚵', 'mountain_bicyclist mountain_biking', 1],
  man_mountain_biking: ['🚵‍♂️', 'mountain_biking_man', 1],
  woman_mountain_biking: ['🚵‍♀️', 'mountain_biking_woman', 1],
  person_cartwheeling: ['🤸', 'cartwheeling person_cartwheel', 1],
  man_cartwheeling: ['🤸‍♂️', 1],
  woman_cartwheeling: ['🤸‍♀️', 1],
  people_wrestling: ['🤼', 'wrestlers wrestling', 1],
  men_wrestling: ['🤼‍♂️', 1],
  women_wrestling: ['🤼‍♀️', 1],
  person_playing_water_polo: ['🤽', 'water_polo', 1],
  man_playing_water_polo: ['🤽‍♂️', 1],
  woman_playing_water_polo: ['🤽‍♀️', 1],
  person_playing_handball: ['🤾', 'handball handball_person', 1],
  man_playing_handball: ['🤾‍♂️', 1],
  woman_playing_handball: ['🤾‍♀️', 1],
  person_juggling: ['🤹', 'juggler juggling juggling_person', 1],
  man_juggling: ['🤹‍♂️', 1],
  woman_juggling: ['🤹‍♀️', 1],
  person_in_lotus_position: ['🧘', 'lotus_position', 1],
  man_in_lotus_position: ['🧘‍♂️', 'lotus_position_man', 1],
  woman_in_lotus_position: ['🧘‍♀️', 'lotus_position_woman', 1],
  person_taking_bath: ['🛀', 'bath', 1],
  person_in_bed: ['🛌', 'sleeping_accommodation sleeping_bed', 1],
  people_holding_hands: ['🧑‍🤝‍🧑', 1],
  women_holding_hands: ['👭', 'two_women_holding_hands', 1],
  woman_and_man_holding_hands: ['👫', 'couple', 1],
  men_holding_hands: ['👬', 'two_men_holding_hands', 1],
  kiss: ['💏', 'couple_kiss couplekiss', 1],
  kiss_woman_man: ['👩‍❤️‍💋‍👨', 'kiss_mw kiss_wm couplekiss_man_woman', 1],
  kiss_man_man: ['👨‍❤️‍💋‍👨', 'kiss_mm couplekiss_man_man', 1],
  kiss_woman_woman: ['👩‍❤️‍💋‍👩', 'kiss_ww couplekiss_woman_woman', 1],
  couple_with_heart: ['💑', 1],
  couple_with_heart_woman_man: ['👩‍❤️‍👨', 'couple_with_heart_mw couple_with_heart_wm', 1],
  couple_with_heart_man_man: ['👨‍❤️‍👨', 'couple_with_heart_mm', 1],
  couple_with_heart_woman_woman: ['👩‍❤️‍👩', 'couple_with_heart_ww', 1],
  family_man_woman_boy: ['👨‍👩‍👦', 'family_mwb', 1],
  family_man_woman_girl: ['👨‍👩‍👧', 'family_mwg', 1],
  family_man_woman_girl_boy: ['👨‍👩‍👧‍👦', 'family_mwgb', 1],
  family_man_woman_boy_boy: ['👨‍👩‍👦‍👦', 'family_mwbb', 1],
  family_man_woman_girl_girl: ['👨‍👩‍👧‍👧', 'family_mwgg', 1],
  family_man_man_boy: ['👨‍👨‍👦', 'family_mmb', 1],
  family_man_man_girl: ['👨‍👨‍👧', 'family_mmg', 1],
  family_man_man_girl_boy: ['👨‍👨‍👧‍👦', 'family_mmgb', 1],
  family_man_man_boy_boy: ['👨‍👨‍👦‍👦', 'family_mmbb', 1],
  family_man_man_girl_girl: ['👨‍👨‍👧‍👧', 'family_mmgg', 1],
  family_woman_woman_boy: ['👩‍👩‍👦', 'family_wwb', 1],
  family_woman_woman_girl: ['👩‍👩‍👧', 'family_wwg', 1],
  family_woman_woman_girl_boy: ['👩‍👩‍👧‍👦', 'family_wwgb', 1],
  family_woman_woman_boy_boy: ['👩‍👩‍👦‍👦', 'family_wwbb', 1],
  family_woman_woman_girl_girl: ['👩‍👩‍👧‍👧', 'family_wwgg', 1],
  family_man_boy: ['👨‍👦', 'family_mb', 1],
  family_man_boy_boy: ['👨‍👦‍👦', 'family_mbb', 1],
  family_man_girl: ['👨‍👧', 'family_mg', 1],
  family_man_girl_boy: ['👨‍👧‍👦', 'family_mgb', 1],
  family_man_girl_girl: ['👨‍👧‍👧', 'family_mgg', 1],
  family_woman_boy: ['👩‍👦', 'family_wb', 1],
  family_woman_boy_boy: ['👩‍👦‍👦', 'family_wbb', 1],
  family_woman_girl: ['👩‍👧', 'family_wg', 1],
  family_woman_girl_boy: ['👩‍👧‍👦', 'family_wgb', 1],
  family_woman_girl_girl: ['👩‍👧‍👧', 'family_wgg', 1],
  speaking_head: ['🗣', 1],
  bust_in_silhouette: ['👤', 1],
  busts_in_silhouette: ['👥', 1],
  people_hugging: ['🫂', 1],
  family: ['👪', 1],
  family_adult_adult_child: ['🧑‍🧑‍🧒', 'family_aac', 1],
  family_adult_adult_child_child: ['🧑‍🧑‍🧒‍🧒', 'family_aacc', 1],
  family_adult_child: ['🧑‍🧒', 'family_aa family_ac', 1],
  family_adult_child_child: ['🧑‍🧒‍🧒', 'family_acc', 1],
  footprints: ['👣', 1],
  fingerprint: ['🫆', 1],
  light_skin_tone: ['🏻', 'tone1 tone_light', 2],
  medium_light_skin_tone: ['🏼', 'tone2 tone_medium_light', 2],
  medium_skin_tone: ['🏽', 'tone3 tone_medium', 2],
  medium_dark_skin_tone: ['🏾', 'tone4 tone_medium_dark', 2],
  dark_skin_tone: ['🏿', 'tone5 tone_dark', 2],
  red_hair: ['🦰', 2],
  curly_hair: ['🦱', 2],
  white_hair: ['🦳', 2],
  bald: ['🦲', 'no_hair', 2],
  monkey_face: ['🐵', 3],
  monkey: ['🐒', 3],
  gorilla: ['🦍', 3],
  orangutan: ['🦧', 3],
  dog_face: ['🐶', 3],
  dog: ['🐕', 'dog2', 3],
  guide_dog: ['🦮', 3],
  service_dog: ['🐕‍🦺', 3],
  poodle: ['🐩', 3],
  wolf: ['🐺', 'wolf_face', 3],
  fox: ['🦊', 'fox_face', 3],
  raccoon: ['🦝', 3],
  cat_face: ['🐱', 3],
  cat: ['🐈', 'cat2', 3],
  black_cat: ['🐈‍⬛', 3],
  lion: ['🦁', 'lion_face', 3],
  tiger_face: ['🐯', 3],
  tiger: ['🐅', 'tiger2', 3],
  leopard: ['🐆', 3],
  horse_face: ['🐴', 3],
  moose: ['🫎', 3],
  donkey: ['🫏', 3],
  horse: ['🐎', 'racehorse', 3],
  unicorn: ['🦄', 'unicorn_face', 3],
  zebra: ['🦓', 3],
  deer: ['🦌', 3],
  bison: ['🦬', 3],
  cow_face: ['🐮', 3],
  ox: ['🐂', 3],
  water_buffalo: ['🐃', 3],
  cow: ['🐄', 'cow2', 3],
  pig_face: ['🐷', 3],
  pig: ['🐖', 'pig2', 3],
  boar: ['🐗', 3],
  pig_nose: ['🐽', 3],
  ram: ['🐏', 3],
  ewe: ['🐑', 'sheep', 3],
  goat: ['🐐', 3],
  camel: ['🐪', 'dromedary_camel', 3],
  two_hump_camel: ['🐫', 'camel', 3],
  llama: ['🦙', 3],
  giraffe: ['🦒', 3],
  elephant: ['🐘', 3],
  mammoth: ['🦣', 3],
  rhinoceros: ['🦏', 'rhino', 3],
  hippopotamus: ['🦛', 'hippo', 3],
  mouse_face: ['🐭', 3],
  mouse: ['🐁', 'mouse2', 3],
  rat: ['🐀', 3],
  hamster: ['🐹', 'hamster_face', 3],
  rabbit_face: ['🐰', 3],
  rabbit: ['🐇', 'rabbit2', 3],
  chipmunk: ['🐿', 3],
  beaver: ['🦫', 3],
  hedgehog: ['🦔', 3],
  bat: ['🦇', 3],
  bear: ['🐻', 'bear_face', 3],
  polar_bear: ['🐻‍❄️', 'polar_bear_face', 3],
  koala: ['🐨', 'koala_face', 3],
  panda: ['🐼', 'panda_face', 3],
  sloth: ['🦥', 3],
  otter: ['🦦', 3],
  skunk: ['🦨', 3],
  kangaroo: ['🦘', 3],
  badger: ['🦡', 3],
  paw_prints: ['🐾', 'feet', 3],
  turkey: ['🦃', 3],
  chicken: ['🐔', 'chicken_face', 3],
  rooster: ['🐓', 3],
  hatching_chick: ['🐣', 3],
  baby_chick: ['🐤', 3],
  front_facing_baby_chick: ['🐥', 'hatched_chick', 3],
  bird: ['🐦', 'bird_face', 3],
  penguin: ['🐧', 'penguin_face', 3],
  dove: ['🕊', 3],
  eagle: ['🦅', 3],
  duck: ['🦆', 3],
  swan: ['🦢', 3],
  owl: ['🦉', 3],
  dodo: ['🦤', 3],
  feather: ['🪶', 3],
  flamingo: ['🦩', 3],
  peacock: ['🦚', 3],
  parrot: ['🦜', 3],
  wing: ['🪽', 3],
  black_bird: ['🐦‍⬛', 3],
  goose: ['🪿', 3],
  phoenix: ['🐦‍🔥', 3],
  frog: ['🐸', 'frog_face', 3],
  crocodile: ['🐊', 3],
  turtle: ['🐢', 3],
  lizard: ['🦎', 3],
  snake: ['🐍', 3],
  dragon_face: ['🐲', 3],
  dragon: ['🐉', 3],
  sauropod: ['🦕', 3],
  trex: ['🦖', 't-rex', 3],
  spouting_whale: ['🐳', 3],
  whale: ['🐋', 'whale2', 3],
  dolphin: ['🐬', 'flipper', 3],
  orca: ['🫍', 3],
  seal: ['🦭', 3],
  fish: ['🐟', 3],
  tropical_fish: ['🐠', 3],
  blowfish: ['🐡', 3],
  shark: ['🦈', 3],
  octopus: ['🐙', 3],
  spiral_shell: ['🐚', 'shell', 3],
  coral: ['🪸', 3],
  jellyfish: ['🪼', 3],
  crab: ['🦀', 3],
  lobster: ['🦞', 3],
  shrimp: ['🦐', 3],
  squid: ['🦑', 3],
  oyster: ['🦪', 3],
  snail: ['🐌', 3],
  butterfly: ['🦋', 3],
  bug: ['🐛', 3],
  ant: ['🐜', 3],
  honeybee: ['🐝', 'bee', 3],
  beetle: ['🪲', 3],
  lady_beetle: ['🐞', 3],
  cricket: ['🦗', 3],
  cockroach: ['🪳', 3],
  spider: ['🕷', 3],
  spider_web: ['🕸', 3],
  scorpion: ['🦂', 3],
  mosquito: ['🦟', 3],
  fly: ['🪰', 3],
  worm: ['🪱', 3],
  microbe: ['🦠', 3],
  bouquet: ['💐', 3],
  cherry_blossom: ['🌸', 3],
  white_flower: ['💮', 3],
  lotus: ['🪷', 3],
  rosette: ['🏵', 3],
  rose: ['🌹', 3],
  wilted_flower: ['🥀', 3],
  hibiscus: ['🌺', 3],
  sunflower: ['🌻', 3],
  blossom: ['🌼', 3],
  tulip: ['🌷', 3],
  hyacinth: ['🪻', 3],
  seedling: ['🌱', 3],
  potted_plant: ['🪴', 3],
  evergreen_tree: ['🌲', 3],
  deciduous_tree: ['🌳', 3],
  palm_tree: ['🌴', 3],
  cactus: ['🌵', 3],
  sheaf_of_rice: ['🌾', 'ear_of_rice', 3],
  herb: ['🌿', 3],
  shamrock: ['☘', 3],
  four_leaf_clover: ['🍀', 3],
  maple_leaf: ['🍁', 3],
  fallen_leaf: ['🍂', 3],
  leaf_fluttering_in_wind: ['🍃', 'leaves', 3],
  empty_nest: ['🪹', 'nest', 3],
  nest_with_eggs: ['🪺', 3],
  mushroom: ['🍄', 3],
  leafless_tree: ['🪾', 3],
  grapes: ['🍇', 4],
  melon: ['🍈', 4],
  watermelon: ['🍉', 4],
  tangerine: ['🍊', 'orange mandarin', 4],
  lemon: ['🍋', 4],
  lime: ['🍋‍🟩', 4],
  banana: ['🍌', 4],
  pineapple: ['🍍', 4],
  mango: ['🥭', 4],
  red_apple: ['🍎', 'apple', 4],
  green_apple: ['🍏', 4],
  pear: ['🍐', 4],
  peach: ['🍑', 4],
  cherries: ['🍒', 4],
  strawberry: ['🍓', 4],
  blueberries: ['🫐', 4],
  kiwi_fruit: ['🥝', 'kiwi', 4],
  tomato: ['🍅', 4],
  olive: ['🫒', 4],
  coconut: ['🥥', 4],
  avocado: ['🥑', 4],
  eggplant: ['🍆', 4],
  potato: ['🥔', 4],
  carrot: ['🥕', 4],
  ear_of_corn: ['🌽', 'corn', 4],
  hot_pepper: ['🌶', 4],
  bell_pepper: ['🫑', 4],
  cucumber: ['🥒', 4],
  leafy_green: ['🥬', 4],
  broccoli: ['🥦', 4],
  garlic: ['🧄', 4],
  onion: ['🧅', 4],
  peanuts: ['🥜', 4],
  beans: ['🫘', 4],
  chestnut: ['🌰', 4],
  ginger_root: ['🫚', 'ginger', 4],
  pea_pod: ['🫛', 'pea', 4],
  brown_mushroom: ['🍄‍🟫', 4],
  root_vegetable: ['🫜', 4],
  bread: ['🍞', 4],
  croissant: ['🥐', 4],
  baguette_bread: ['🥖', 4],
  flatbread: ['🫓', 4],
  pretzel: ['🥨', 4],
  bagel: ['🥯', 4],
  pancakes: ['🥞', 4],
  waffle: ['🧇', 4],
  cheese_wedge: ['🧀', 'cheese', 4],
  meat_on_bone: ['🍖', 4],
  poultry_leg: ['🍗', 4],
  cut_of_meat: ['🥩', 4],
  bacon: ['🥓', 4],
  hamburger: ['🍔', 4],
  french_fries: ['🍟', 'fries', 4],
  pizza: ['🍕', 4],
  hot_dog: ['🌭', 'hotdog', 4],
  sandwich: ['🥪', 4],
  taco: ['🌮', 4],
  burrito: ['🌯', 4],
  tamale: ['🫔', 4],
  stuffed_flatbread: ['🥙', 4],
  falafel: ['🧆', 4],
  egg: ['🥚', 4],
  cooking: ['🍳', 'fried_egg', 4],
  shallow_pan_of_food: ['🥘', 4],
  pot_of_food: ['🍲', 'stew', 4],
  fondue: ['🫕', 4],
  bowl_with_spoon: ['🥣', 4],
  green_salad: ['🥗', 'salad', 4],
  popcorn: ['🍿', 4],
  butter: ['🧈', 4],
  salt: ['🧂', 4],
  canned_food: ['🥫', 4],
  bento_box: ['🍱', 'bento', 4],
  rice_cracker: ['🍘', 4],
  rice_ball: ['🍙', 4],
  cooked_rice: ['🍚', 'rice', 4],
  curry_rice: ['🍛', 'curry', 4],
  steaming_bowl: ['🍜', 'ramen', 4],
  spaghetti: ['🍝', 4],
  roasted_sweet_potato: ['🍠', 'sweet_potato', 4],
  oden: ['🍢', 4],
  sushi: ['🍣', 4],
  fried_shrimp: ['🍤', 4],
  fish_cake_with_swirl: ['🍥', 'fish_cake', 4],
  moon_cake: ['🥮', 4],
  dango: ['🍡', 4],
  dumpling: ['🥟', 4],
  fortune_cookie: ['🥠', 4],
  takeout_box: ['🥡', 4],
  soft_ice_cream: ['🍦', 'icecream soft_serve', 4],
  shaved_ice: ['🍧', 4],
  ice_cream: ['🍨', 4],
  doughnut: ['🍩', 4],
  cookie: ['🍪', 4],
  birthday_cake: ['🎂', 'birthday', 4],
  shortcake: ['🍰', 'cake', 4],
  cupcake: ['🧁', 4],
  pie: ['🥧', 4],
  chocolate_bar: ['🍫', 4],
  candy: ['🍬', 4],
  lollipop: ['🍭', 4],
  custard: ['🍮', 4],
  honey_pot: ['🍯', 4],
  baby_bottle: ['🍼', 4],
  glass_of_milk: ['🥛', 'milk milk_glass', 4],
  hot_beverage: ['☕', 'coffee', 4],
  teapot: ['🫖', 4],
  teacup_without_handle: ['🍵', 'tea', 4],
  sake: ['🍶', 4],
  bottle_with_popping_cork: ['🍾', 'champagne', 4],
  wine_glass: ['🍷', 4],
  cocktail_glass: ['🍸', 'cocktail', 4],
  tropical_drink: ['🍹', 4],
  beer_mug: ['🍺', 'beer', 4],
  clinking_beer_mugs: ['🍻', 'beers', 4],
  clinking_glasses: ['🥂', 4],
  tumbler_glass: ['🥃', 'whisky', 4],
  pouring_liquid: ['🫗', 'pour', 4],
  cup_with_straw: ['🥤', 4],
  bubble_tea: ['🧋', 'boba_drink', 4],
  beverage_box: ['🧃', 'juice_box', 4],
  mate: ['🧉', 4],
  ice: ['🧊', 'ice_cube', 4],
  chopsticks: ['🥢', 4],
  fork_and_knife_with_plate: ['🍽', 'fork_knife_plate plate_with_cutlery', 4],
  fork_and_knife: ['🍴', 4],
  spoon: ['🥄', 4],
  kitchen_knife: ['🔪', 'knife hocho', 4],
  jar: ['🫙', 4],
  amphora: ['🏺', 4],
  globe_showing_europe_africa: ['🌍', 'earth_africa earth_europe', 5],
  globe_showing_americas: ['🌎', 'earth_americas', 5],
  globe_showing_asia_australia: ['🌏', 'earth_asia', 5],
  globe_with_meridians: ['🌐', 5],
  world_map: ['🗺', 5],
  map_of_japan: ['🗾', 'japan_map', 5],
  compass: ['🧭', 5],
  snow_capped_mountain: ['🏔', 'mountain_snow', 5],
  mountain: ['⛰', 5],
  landslide: ['🛘', 5],
  volcano: ['🌋', 5],
  mount_fuji: ['🗻', 5],
  camping: ['🏕', 5],
  beach_with_umbrella: ['🏖', 'beach', 5],
  desert: ['🏜', 5],
  desert_island: ['🏝', 'island', 5],
  national_park: ['🏞', 5],
  stadium: ['🏟', 5],
  classical_building: ['🏛', 5],
  building_construction: ['🏗', 'construction_site', 5],
  brick: ['🧱', 'bricks', 5],
  rock: ['🪨', 5],
  wood: ['🪵', 5],
  hut: ['🛖', 5],
  houses: ['🏘', 'homes', 5],
  derelict_house: ['🏚', 'house_abandoned', 5],
  house: ['🏠', 5],
  house_with_garden: ['🏡', 5],
  office_building: ['🏢', 'office', 5],
  japanese_post_office: ['🏣', 'post_office', 5],
  post_office: ['🏤', 'european_post_office', 5],
  hospital: ['🏥', 5],
  bank: ['🏦', 5],
  hotel: ['🏨', 5],
  love_hotel: ['🏩', 5],
  convenience_store: ['🏪', 5],
  school: ['🏫', 5],
  department_store: ['🏬', 5],
  factory: ['🏭', 5],
  japanese_castle: ['🏯', 5],
  castle: ['🏰', 'european_castle', 5],
  wedding: ['💒', 5],
  tokyo_tower: ['🗼', 5],
  statue_of_liberty: ['🗽', 5],
  church: ['⛪', 5],
  mosque: ['🕌', 5],
  hindu_temple: ['🛕', 5],
  synagogue: ['🕍', 5],
  shinto_shrine: ['⛩', 5],
  kaaba: ['🕋', 5],
  fountain: ['⛲', 5],
  tent: ['⛺', 5],
  foggy: ['🌁', 5],
  night_with_stars: ['🌃', 5],
  cityscape: ['🏙', 5],
  sunrise_over_mountains: ['🌄', 5],
  sunrise: ['🌅', 5],
  cityscape_at_dusk: ['🌆', 'city_dusk', 5],
  sunset: ['🌇', 'city_sunrise city_sunset', 5],
  bridge_at_night: ['🌉', 5],
  hot_springs: ['♨', 'hotsprings', 5],
  carousel_horse: ['🎠', 5],
  playground_slide: ['🛝', 'slide', 5],
  ferris_wheel: ['🎡', 5],
  roller_coaster: ['🎢', 5],
  barber_pole: ['💈', 'barber', 5],
  circus_tent: ['🎪', 5],
  locomotive: ['🚂', 'steam_locomotive', 5],
  railway_car: ['🚃', 5],
  high_speed_train: ['🚄', 'bullettrain_side', 5],
  bullet_train: ['🚅', 'bullettrain_front', 5],
  train: ['🚆', 'train2', 5],
  metro: ['🚇', 5],
  light_rail: ['🚈', 5],
  station: ['🚉', 5],
  tram: ['🚊', 5],
  monorail: ['🚝', 5],
  mountain_railway: ['🚞', 5],
  tram_car: ['🚋', 5],
  bus: ['🚌', 5],
  oncoming_bus: ['🚍', 5],
  trolleybus: ['🚎', 5],
  minibus: ['🚐', 5],
  ambulance: ['🚑', 5],
  fire_engine: ['🚒', 5],
  police_car: ['🚓', 5],
  oncoming_police_car: ['🚔', 5],
  taxi: ['🚕', 5],
  oncoming_taxi: ['🚖', 5],
  automobile: ['🚗', 'car red_car', 5],
  oncoming_automobile: ['🚘', 5],
  sport_utility_vehicle: ['🚙', 'blue_car suv', 5],
  pickup_truck: ['🛻', 5],
  delivery_truck: ['🚚', 'truck', 5],
  articulated_lorry: ['🚛', 5],
  tractor: ['🚜', 5],
  racing_car: ['🏎', 5],
  motorcycle: ['🏍', 5],
  motor_scooter: ['🛵', 5],
  manual_wheelchair: ['🦽', 5],
  motorized_wheelchair: ['🦼', 5],
  auto_rickshaw: ['🛺', 5],
  bicycle: ['🚲', 'bike', 5],
  kick_scooter: ['🛴', 'scooter', 5],
  skateboard: ['🛹', 5],
  roller_skate: ['🛼', 5],
  bus_stop: ['🚏', 'busstop', 5],
  motorway: ['🛣', 5],
  railway_track: ['🛤', 5],
  oil_drum: ['🛢', 5],
  fuel_pump: ['⛽', 'fuelpump', 5],
  wheel: ['🛞', 5],
  police_car_light: ['🚨', 'rotating_light', 5],
  horizontal_traffic_light: ['🚥', 'traffic_light', 5],
  vertical_traffic_light: ['🚦', 5],
  stop_sign: ['🛑', 'octagonal_sign', 5],
  construction: ['🚧', 5],
  anchor: ['⚓', 5],
  ring_buoy: ['🛟', 'lifebuoy', 5],
  sailboat: ['⛵', 'boat', 5],
  canoe: ['🛶', 5],
  speedboat: ['🚤', 5],
  passenger_ship: ['🛳', 'cruise_ship', 5],
  ferry: ['⛴', 5],
  motor_boat: ['🛥', 'motorboat', 5],
  ship: ['🚢', 5],
  airplane: ['✈', 5],
  small_airplane: ['🛩', 5],
  airplane_departure: ['🛫', 'flight_departure', 5],
  airplane_arrival: ['🛬', 'airplane_arriving flight_arrival', 5],
  parachute: ['🪂', 5],
  seat: ['💺', 5],
  helicopter: ['🚁', 5],
  suspension_railway: ['🚟', 5],
  mountain_cableway: ['🚠', 5],
  aerial_tramway: ['🚡', 5],
  satellite: ['🛰', 'artificial_satellite', 5],
  rocket: ['🚀', 5],
  flying_saucer: ['🛸', 5],
  bellhop_bell: ['🛎', 'bellhop', 5],
  luggage: ['🧳', 5],
  hourglass_done: ['⌛', 'hourglass', 5],
  hourglass_not_done: ['⏳', 'hourglass_flowing_sand', 5],
  watch: ['⌚', 5],
  alarm_clock: ['⏰', 5],
  stopwatch: ['⏱', 5],
  timer_clock: ['⏲', 5],
  mantelpiece_clock: ['🕰', 'clock', 5],
  twelve_oclock: ['🕛', 'clock12', 5],
  twelve_thirty: ['🕧', 'clock1230', 5],
  one_oclock: ['🕐', 'clock1', 5],
  one_thirty: ['🕜', 'clock130', 5],
  two_oclock: ['🕑', 'clock2', 5],
  two_thirty: ['🕝', 'clock230', 5],
  three_oclock: ['🕒', 'clock3', 5],
  three_thirty: ['🕞', 'clock330', 5],
  four_oclock: ['🕓', 'clock4', 5],
  four_thirty: ['🕟', 'clock430', 5],
  five_oclock: ['🕔', 'clock5', 5],
  five_thirty: ['🕠', 'clock530', 5],
  six_oclock: ['🕕', 'clock6', 5],
  six_thirty: ['🕡', 'clock630', 5],
  seven_oclock: ['🕖', 'clock7', 5],
  seven_thirty: ['🕢', 'clock730', 5],
  eight_oclock: ['🕗', 'clock8', 5],
  eight_thirty: ['🕣', 'clock830', 5],
  nine_oclock: ['🕘', 'clock9', 5],
  nine_thirty: ['🕤', 'clock930', 5],
  ten_oclock: ['🕙', 'clock10', 5],
  ten_thirty: ['🕥', 'clock1030', 5],
  eleven_oclock: ['🕚', 'clock11', 5],
  eleven_thirty: ['🕦', 'clock1130', 5],
  new_moon: ['🌑', 5],
  waxing_crescent_moon: ['🌒', 5],
  first_quarter_moon: ['🌓', 5],
  waxing_gibbous_moon: ['🌔', 'moon', 5],
  full_moon: ['🌕', 5],
  waning_gibbous_moon: ['🌖', 5],
  last_quarter_moon: ['🌗', 5],
  waning_crescent_moon: ['🌘', 5],
  crescent_moon: ['🌙', 5],
  new_moon_face: ['🌚', 'new_moon_with_face', 5],
  first_quarter_moon_face: ['🌛', 'first_quarter_moon_with_face', 5],
  last_quarter_moon_face: ['🌜', 'last_quarter_moon_with_face', 5],
  thermometer: ['🌡', 5],
  sun: ['☀', 5],
  full_moon_face: ['🌝', 'full_moon_with_face', 5],
  sun_with_face: ['🌞', 5],
  ringed_planet: ['🪐', 'saturn', 5],
  star: ['⭐', 5],
  glowing_star: ['🌟', 'star2', 5],
  shooting_star: ['🌠', 'stars', 5],
  milky_way: ['🌌', 5],
  cloud: ['☁', 5],
  sun_behind_cloud: ['⛅', 'partly_sunny', 5],
  cloud_with_lightning_and_rain: ['⛈', 'stormy thunder_cloud_and_rain', 5],
  sun_behind_small_cloud: ['🌤', 'sunny', 5],
  sun_behind_large_cloud: ['🌥', 'cloudy', 5],
  sun_behind_rain_cloud: ['🌦', 'sun_and_rain', 5],
  cloud_with_rain: ['🌧', 'rainy', 5],
  cloud_with_snow: ['🌨', 'snowy', 5],
  cloud_with_lightning: ['🌩', 'lightning', 5],
  tornado: ['🌪', 5],
  fog: ['🌫', 5],
  wind_face: ['🌬', 'wind_blowing_face', 5],
  cyclone: ['🌀', 5],
  rainbow: ['🌈', 5],
  closed_umbrella: ['🌂', 5],
  umbrella: ['☂', 'open_umbrella', 5],
  umbrella_with_rain_drops: ['☔', 'umbrella_with_rain', 5],
  umbrella_on_ground: ['⛱', 'beach_umbrella parasol_on_ground', 5],
  high_voltage: ['⚡', 'zap', 5],
  snowflake: ['❄', 5],
  snowman: ['☃', 'snowman2 snowman_with_snow', 5],
  snowman_without_snow: ['⛄', 'snowman', 5],
  comet: ['☄', 5],
  fire: ['🔥', 5],
  droplet: ['💧', 5],
  water_wave: ['🌊', 'ocean', 5],
  jack_o_lantern: ['🎃', 6],
  christmas_tree: ['🎄', 6],
  fireworks: ['🎆', 6],
  sparkler: ['🎇', 6],
  firecracker: ['🧨', 6],
  sparkles: ['✨', 6],
  balloon: ['🎈', 6],
  party_popper: ['🎉', 'party tada', 6],
  confetti_ball: ['🎊', 6],
  tanabata_tree: ['🎋', 6],
  pine_decoration: ['🎍', 'bamboo', 6],
  japanese_dolls: ['🎎', 'dolls', 6],
  carp_streamer: ['🎏', 'flags', 6],
  wind_chime: ['🎐', 6],
  moon_viewing_ceremony: ['🎑', 'moon_ceremony rice_scene', 6],
  red_envelope: ['🧧', 6],
  ribbon: ['🎀', 6],
  wrapped_gift: ['🎁', 'gift', 6],
  reminder_ribbon: ['🎗', 6],
  admission_tickets: ['🎟', 'tickets', 6],
  ticket: ['🎫', 6],
  military_medal: ['🎖', 'medal_military', 6],
  trophy: ['🏆', 6],
  sports_medal: ['🏅', 'medal_sports', 6],
  '1st_place_medal': ['🥇', '1st first_place_medal', 6],
  '2nd_place_medal': ['🥈', '2nd second_place_medal', 6],
  '3rd_place_medal': ['🥉', '3rd third_place_medal', 6],
  soccer_ball: ['⚽', 'soccer', 6],
  baseball: ['⚾', 6],
  softball: ['🥎', 6],
  basketball: ['🏀', 6],
  volleyball: ['🏐', 6],
  american_football: ['🏈', 'football', 6],
  rugby_football: ['🏉', 6],
  tennis: ['🎾', 6],
  flying_disc: ['🥏', 6],
  bowling: ['🎳', 6],
  cricket_game: ['🏏', 6],
  field_hockey: ['🏑', 6],
  ice_hockey: ['🏒', 'hockey', 6],
  lacrosse: ['🥍', 6],
  ping_pong: ['🏓', 6],
  badminton: ['🏸', 6],
  boxing_glove: ['🥊', 6],
  martial_arts_uniform: ['🥋', 6],
  goal_net: ['🥅', 6],
  flag_in_hole: ['⛳', 'golf', 6],
  ice_skate: ['⛸', 6],
  fishing_pole: ['🎣', 'fishing_pole_and_fish', 6],
  diving_mask: ['🤿', 6],
  running_shirt: ['🎽', 'running_shirt_with_sash', 6],
  skis: ['🎿', 'ski', 6],
  sled: ['🛷', 6],
  curling_stone: ['🥌', 6],
  bullseye: ['🎯', 'dart direct_hit', 6],
  yo_yo: ['🪀', 6],
  kite: ['🪁', 6],
  water_pistol: ['🔫', 'gun pistol', 6],
  pool_8_ball: ['🎱', '8ball billiards', 6],
  crystal_ball: ['🔮', 6],
  magic_wand: ['🪄', 6],
  video_game: ['🎮', 'controller', 6],
  joystick: ['🕹', 6],
  slot_machine: ['🎰', 6],
  game_die: ['🎲', 6],
  puzzle_piece: ['🧩', 'jigsaw', 6],
  teddy_bear: ['🧸', 6],
  pinata: ['🪅', 6],
  mirror_ball: ['🪩', 'disco disco_ball', 6],
  nesting_dolls: ['🪆', 6],
  spade_suit: ['♠', 'spades', 6],
  heart_suit: ['♥', 'hearts', 6],
  diamond_suit: ['♦', 'diamonds', 6],
  club_suit: ['♣', 'clubs', 6],
  chess_pawn: ['♟', 6],
  joker: ['🃏', 'black_joker', 6],
  mahjong_red_dragon: ['🀄', 'mahjong', 6],
  flower_playing_cards: ['🎴', 6],
  performing_arts: ['🎭', 6],
  framed_picture: ['🖼', 'frame_with_picture', 6],
  artist_palette: ['🎨', 'art palette', 6],
  thread: ['🧵', 6],
  sewing_needle: ['🪡', 6],
  yarn: ['🧶', 6],
  knot: ['🪢', 6],
  glasses: ['👓', 'eyeglasses', 7],
  sunglasses: ['🕶', 'dark_sunglasses', '8-) B-)', 7],
  goggles: ['🥽', 7],
  lab_coat: ['🥼', 7],
  safety_vest: ['🦺', 7],
  necktie: ['👔', 7],
  t_shirt: ['👕', 'shirt tshirt', 7],
  jeans: ['👖', 7],
  scarf: ['🧣', 7],
  gloves: ['🧤', 7],
  coat: ['🧥', 7],
  socks: ['🧦', 7],
  dress: ['👗', 7],
  kimono: ['👘', 7],
  sari: ['🥻', 7],
  one_piece_swimsuit: ['🩱', 7],
  briefs: ['🩲', 'swim_brief', 7],
  shorts: ['🩳', 7],
  bikini: ['👙', 7],
  womans_clothes: ['👚', 7],
  folding_hand_fan: ['🪭', 'folding_fan', 7],
  purse: ['👛', 7],
  handbag: ['👜', 7],
  clutch_bag: ['👝', 'pouch', 7],
  shopping_bags: ['🛍', 'shopping', 7],
  backpack: ['🎒', 'school_satchel', 7],
  thong_sandal: ['🩴', 7],
  mans_shoe: ['👞', 'shoe', 7],
  running_shoe: ['👟', 'athletic_shoe sneaker', 7],
  hiking_boot: ['🥾', 7],
  flat_shoe: ['🥿', 'womans_flat_shoe', 7],
  high_heeled_shoe: ['👠', 'high_heel', 7],
  womans_sandal: ['👡', 'sandal', 7],
  ballet_shoes: ['🩰', 7],
  womans_boot: ['👢', 'boot', 7],
  hair_pick: ['🪮', 7],
  crown: ['👑', 7],
  womans_hat: ['👒', 7],
  top_hat: ['🎩', 'tophat', 7],
  graduation_cap: ['🎓', 'mortar_board', 7],
  billed_cap: ['🧢', 7],
  military_helmet: ['🪖', 7],
  rescue_workers_helmet: ['⛑', 'helmet_with_cross rescue_worker_helmet', 7],
  prayer_beads: ['📿', 7],
  lipstick: ['💄', 7],
  ring: ['💍', 7],
  gem_stone: ['💎', 'gem', 7],
  muted_speaker: ['🔇', 'mute no_sound', 7],
  speaker_low_volume: ['🔈', 'low_volume quiet_sound speaker', 7],
  speaker_medium_volume: ['🔉', 'medium_volumne sound', 7],
  speaker_high_volume: ['🔊', 'high_volume loud_sound', 7],
  loudspeaker: ['📢', 7],
  megaphone: ['📣', 'mega', 7],
  postal_horn: ['📯', 7],
  bell: ['🔔', 7],
  bell_with_slash: ['🔕', 'no_bell', 7],
  musical_score: ['🎼', 7],
  musical_note: ['🎵', 7],
  musical_notes: ['🎶', 'notes', 7],
  studio_microphone: ['🎙', 7],
  level_slider: ['🎚', 7],
  control_knobs: ['🎛', 7],
  microphone: ['🎤', 7],
  headphone: ['🎧', 'headphones', 7],
  radio: ['📻', 7],
  saxophone: ['🎷', 7],
  trumpet: ['🎺', 7],
  trombone: ['🪊', 7],
  accordion: ['🪗', 7],
  guitar: ['🎸', 7],
  musical_keyboard: ['🎹', 7],
  violin: ['🎻', 7],
  banjo: ['🪕', 7],
  drum: ['🥁', 7],
  long_drum: ['🪘', 7],
  maracas: ['🪇', 7],
  flute: ['🪈', 7],
  harp: ['🪉', 7],
  mobile_phone: ['📱', 'android iphone', 7],
  mobile_phone_with_arrow: ['📲', 'calling mobile_phone_arrow', 7],
  telephone: ['☎', 'phone', 7],
  telephone_receiver: ['📞', 7],
  pager: ['📟', 7],
  fax_machine: ['📠', 'fax', 7],
  battery: ['🔋', 7],
  low_battery: ['🪫', 7],
  electric_plug: ['🔌', 7],
  laptop: ['💻', 7],
  desktop_computer: ['🖥', 'computer', 7],
  printer: ['🖨', 7],
  keyboard: ['⌨', 7],
  computer_mouse: ['🖱', 7],
  trackball: ['🖲', 7],
  computer_disk: ['💽', 'minidisc', 7],
  floppy_disk: ['💾', 7],
  optical_disk: ['💿', 'cd', 7],
  dvd: ['📀', 7],
  abacus: ['🧮', 7],
  movie_camera: ['🎥', 7],
  film_frames: ['🎞', 'film_strip', 7],
  film_projector: ['📽', 7],
  clapper_board: ['🎬', 'clapper', 7],
  television: ['📺', 'tv', 7],
  camera: ['📷', 7],
  camera_with_flash: ['📸', 'camera_flash', 7],
  video_camera: ['📹', 7],
  videocassette: ['📼', 'vhs', 7],
  magnifying_glass_tilted_left: ['🔍', 'mag', 7],
  magnifying_glass_tilted_right: ['🔎', 'mag_right', 7],
  candle: ['🕯', 7],
  light_bulb: ['💡', 'bulb', 7],
  flashlight: ['🔦', 7],
  red_paper_lantern: ['🏮', 'izakaya_lantern lantern', 7],
  diya_lamp: ['🪔', 7],
  notebook_with_decorative_cover: ['📔', 7],
  closed_book: ['📕', 7],
  open_book: ['📖', 'book', 7],
  green_book: ['📗', 7],
  blue_book: ['📘', 7],
  orange_book: ['📙', 7],
  books: ['📚', 7],
  notebook: ['📓', 7],
  ledger: ['📒', 7],
  page_with_curl: ['📃', 7],
  scroll: ['📜', 7],
  page_facing_up: ['📄', 7],
  newspaper: ['📰', 7],
  rolled_up_newspaper: ['🗞', 'newspaper_roll', 7],
  bookmark_tabs: ['📑', 7],
  bookmark: ['🔖', 7],
  label: ['🏷', 7],
  coin: ['🪙', 7],
  money_bag: ['💰', 'moneybag', 7],
  treasure_chest: ['🪎', 7],
  yen_banknote: ['💴', 'yen', 7],
  dollar_banknote: ['💵', 'dollar', 7],
  euro_banknote: ['💶', 'euro', 7],
  pound_banknote: ['💷', 'pound', 7],
  money_with_wings: ['💸', 7],
  credit_card: ['💳', 7],
  receipt: ['🧾', 7],
  chart_increasing_with_yen: ['💹', 'chart', 7],
  envelope: ['✉', 7],
  email: ['📧', 'e-mail', 7],
  incoming_envelope: ['📨', 7],
  envelope_with_arrow: ['📩', 7],
  outbox_tray: ['📤', 7],
  inbox_tray: ['📥', 7],
  package: ['📦', 7],
  closed_mailbox_with_raised_flag: ['📫', 'mailbox', 7],
  closed_mailbox_with_lowered_flag: ['📪', 'mailbox_closed', 7],
  open_mailbox_with_raised_flag: ['📬', 'mailbox_with_mail', 7],
  open_mailbox_with_lowered_flag: ['📭', 'mailbox_with_no_mail', 7],
  postbox: ['📮', 7],
  ballot_box_with_ballot: ['🗳', 'ballot_box', 7],
  pencil: ['✏', 'pencil2', 7],
  black_nib: ['✒', 7],
  fountain_pen: ['🖋', 7],
  pen: ['🖊', 7],
  paintbrush: ['🖌', 7],
  crayon: ['🖍', 7],
  memo: ['📝', 7],
  briefcase: ['💼', 7],
  file_folder: ['📁', 7],
  open_file_folder: ['📂', 7],
  card_index_dividers: ['🗂', 7],
  calendar: ['📅', 'date', 7],
  tear_off_calendar: ['📆', 'calendar', 7],
  spiral_notepad: ['🗒', 'notepad_spiral', 7],
  spiral_calendar: ['🗓', 'calendar_spiral', 7],
  card_index: ['📇', 7],
  chart_increasing: ['📈', 'chart_with_upwards_trend', 7],
  chart_decreasing: ['📉', 'chart_with_downwards_trend', 7],
  bar_chart: ['📊', 7],
  clipboard: ['📋', 7],
  pushpin: ['📌', 7],
  round_pushpin: ['📍', 7],
  paperclip: ['📎', 7],
  linked_paperclips: ['🖇', 'paperclips', 7],
  straight_ruler: ['📏', 7],
  triangular_ruler: ['📐', 7],
  scissors: ['✂', 7],
  card_file_box: ['🗃', 7],
  file_cabinet: ['🗄', 7],
  wastebasket: ['🗑', 'trashcan', 7],
  locked: ['🔒', 'lock', 7],
  unlocked: ['🔓', 'unlock', 7],
  locked_with_pen: ['🔏', 'lock_with_ink_pen', 7],
  locked_with_key: ['🔐', 'closed_lock_with_key', 7],
  key: ['🔑', 7],
  old_key: ['🗝', 7],
  hammer: ['🔨', 7],
  axe: ['🪓', 7],
  pick: ['⛏', 7],
  hammer_and_pick: ['⚒', 7],
  hammer_and_wrench: ['🛠', 7],
  dagger: ['🗡', 7],
  crossed_swords: ['⚔', 7],
  bomb: ['💣', 7],
  boomerang: ['🪃', 7],
  bow_and_arrow: ['🏹', 7],
  shield: ['🛡', 7],
  carpentry_saw: ['🪚', 7],
  wrench: ['🔧', 7],
  screwdriver: ['🪛', 7],
  nut_and_bolt: ['🔩', 7],
  gear: ['⚙', 7],
  clamp: ['🗜', 'compression', 7],
  balance_scale: ['⚖', 'scales', 7],
  white_cane: ['🦯', 'probing_cane', 7],
  link: ['🔗', 7],
  broken_chain: ['⛓️‍💥', 7],
  chains: ['⛓', 7],
  hook: ['🪝', 7],
  toolbox: ['🧰', 7],
  magnet: ['🧲', 7],
  ladder: ['🪜', 7],
  shovel: ['🪏', 7],
  alembic: ['⚗', 7],
  test_tube: ['🧪', 7],
  petri_dish: ['🧫', 7],
  dna: ['🧬', 'double_helix', 7],
  microscope: ['🔬', 7],
  telescope: ['🔭', 7],
  satellite_antenna: ['📡', 7],
  syringe: ['💉', 7],
  drop_of_blood: ['🩸', 7],
  pill: ['💊', 7],
  adhesive_bandage: ['🩹', 'bandaid', 7],
  crutch: ['🩼', 7],
  stethoscope: ['🩺', 7],
  x_ray: ['🩻', 'x-ray xray', 7],
  door: ['🚪', 7],
  elevator: ['🛗', 7],
  mirror: ['🪞', 7],
  window: ['🪟', 7],
  bed: ['🛏', 7],
  couch_and_lamp: ['🛋', 7],
  chair: ['🪑', 7],
  toilet: ['🚽', 7],
  plunger: ['🪠', 7],
  shower: ['🚿', 7],
  bathtub: ['🛁', 7],
  mouse_trap: ['🪤', 7],
  razor: ['🪒', 7],
  lotion_bottle: ['🧴', 7],
  safety_pin: ['🧷', 7],
  broom: ['🧹', 7],
  basket: ['🧺', 7],
  roll_of_paper: ['🧻', 'toilet_paper', 7],
  bucket: ['🪣', 7],
  soap: ['🧼', 7],
  bubbles: ['🫧', 7],
  toothbrush: ['🪥', 7],
  sponge: ['🧽', 7],
  fire_extinguisher: ['🧯', 7],
  shopping_cart: ['🛒', 7],
  cigarette: ['🚬', 'smoking', 7],
  coffin: ['⚰', 7],
  headstone: ['🪦', 7],
  funeral_urn: ['⚱', 7],
  nazar_amulet: ['🧿', 7],
  hamsa: ['🪬', 7],
  moai: ['🗿', 'moyai', 7],
  placard: ['🪧', 7],
  identification_card: ['🪪', 'id_card', 7],
  atm_sign: ['🏧', 'atm', 8],
  litter_in_bin_sign: ['🚮', 'litter_bin put_litter_in_its_place', 8],
  potable_water: ['🚰', 8],
  wheelchair_symbol: ['♿', 'handicapped wheelchair', 8],
  mens_room: ['🚹', 'mens', 8],
  womens_room: ['🚺', 'womens', 8],
  restroom: ['🚻', 'bathroom', 8],
  baby_symbol: ['🚼', 8],
  water_closet: ['🚾', 'wc', 8],
  passport_control: ['🛂', 8],
  customs: ['🛃', 8],
  baggage_claim: ['🛄', 8],
  left_luggage: ['🛅', 8],
  warning: ['⚠', 8],
  children_crossing: ['🚸', 8],
  no_entry: ['⛔', 8],
  prohibited: ['🚫', 'no_entry_sign', 8],
  no_bicycles: ['🚳', 8],
  no_smoking: ['🚭', 8],
  no_littering: ['🚯', 'do_not_litter', 8],
  non_potable_water: ['🚱', 'non-potable_water', 8],
  no_pedestrians: ['🚷', 8],
  no_mobile_phones: ['📵', 8],
  no_one_under_eighteen: ['🔞', 'no_one_under_18 underage', 8],
  radioactive: ['☢', 8],
  biohazard: ['☣', 8],
  up_arrow: ['⬆', 'arrow_up', 8],
  up_right_arrow: ['↗', 'arrow_upper_right', 8],
  right_arrow: ['➡', 'arrow_right', 8],
  down_right_arrow: ['↘', 'arrow_lower_right', 8],
  down_arrow: ['⬇', 'arrow_down', 8],
  down_left_arrow: ['↙', 'arrow_lower_left', 8],
  left_arrow: ['⬅', 'arrow_left', 8],
  up_left_arrow: ['↖', 'arrow_upper_left', 8],
  up_down_arrow: ['↕', 'arrow_up_down', 8],
  left_right_arrow: ['↔', 8],
  right_arrow_curving_left: ['↩', 'arrow_left_hook leftwards_arrow_with_hook', 8],
  left_arrow_curving_right: ['↪', 'arrow_right_hook rightwards_arrow_with_hook', 8],
  right_arrow_curving_up: ['⤴', 'arrow_heading_up', 8],
  right_arrow_curving_down: ['⤵', 'arrow_heading_down', 8],
  clockwise_vertical_arrows: ['🔃', 'arrows_clockwise clockwise', 8],
  counterclockwise_arrows_button: ['🔄', 'arrows_counterclockwise counterclockwise', 8],
  back_arrow: ['🔙', 'back', 8],
  end_arrow: ['🔚', 'end', 8],
  on_arrow: ['🔛', 'on', 8],
  soon_arrow: ['🔜', 'soon', 8],
  top_arrow: ['🔝', 'top', 8],
  place_of_worship: ['🛐', 8],
  atom_symbol: ['⚛', 'atom', 8],
  om: ['🕉', 8],
  star_of_david: ['✡', 8],
  wheel_of_dharma: ['☸', 8],
  yin_yang: ['☯', 8],
  latin_cross: ['✝', 8],
  orthodox_cross: ['☦', 8],
  star_and_crescent: ['☪', 8],
  peace_symbol: ['☮', 'peace', 8],
  menorah: ['🕎', 8],
  dotted_six_pointed_star: ['🔯', 'six_pointed_star', 8],
  khanda: ['🪯', 8],
  aries: ['♈', 8],
  taurus: ['♉', 8],
  gemini: ['♊', 8],
  cancer: ['♋', 8],
  leo: ['♌', 8],
  virgo: ['♍', 8],
  libra: ['♎', 8],
  scorpio: ['♏', 'scorpius', 8],
  sagittarius: ['♐', 8],
  capricorn: ['♑', 8],
  aquarius: ['♒', 8],
  pisces: ['♓', 8],
  ophiuchus: ['⛎', 8],
  shuffle_tracks_button: ['🔀', 'shuffle twisted_rightwards_arrows', 8],
  repeat_button: ['🔁', 'repeat', 8],
  repeat_single_button: ['🔂', 'repeat_one', 8],
  play_button: ['▶', 'arrow_forward play', 8],
  fast_forward_button: ['⏩', 'fast_forward', 8],
  next_track_button: ['⏭', 'next_track', 8],
  play_or_pause_button: ['⏯', 'play_pause', 8],
  reverse_button: ['◀', 'arrow_backward reverse', 8],
  fast_reverse_button: ['⏪', 'fast_reverse rewind', 8],
  last_track_button: ['⏮', 'previous_track previous_track_button', 8],
  upwards_button: ['🔼', 'arrow_up_small up', 8],
  fast_up_button: ['⏫', 'arrow_double_up fast_up', 8],
  downwards_button: ['🔽', 'arrow_down_small down', 8],
  fast_down_button: ['⏬', 'arrow_double_down fast_down', 8],
  pause_button: ['⏸', 'pause', 8],
  stop_button: ['⏹', 'stop', 8],
  record_button: ['⏺', 'record', 8],
  eject_button: ['⏏', 'eject', 8],
  cinema: ['🎦', 8],
  dim_button: ['🔅', 'low_brightness', 8],
  bright_button: ['🔆', 'high_brightness', 8],
  antenna_bars: ['📶', 'signal_strength', 8],
  wireless: ['🛜', 8],
  vibration_mode: ['📳', 8],
  mobile_phone_off: ['📴', 8],
  female_sign: ['♀', 'female', 8],
  male_sign: ['♂', 'male', 8],
  transgender_symbol: ['⚧', 8],
  multiply: ['✖', 'multiplication heavy_multiplication_x', 8],
  plus: ['➕', 'heavy_plus_sign', 8],
  minus: ['➖', 'heavy_minus_sign', 8],
  divide: ['➗', 'division heavy_division_sign', 8],
  heavy_equals_sign: ['🟰', 8],
  infinity: ['♾', 8],
  double_exclamation_mark: ['‼', 'bangbang double_exclamation', 8],
  exclamation_question_mark: ['⁉', 'exclamation_question interrobang', 8],
  red_question_mark: ['❓', 'question', 8],
  white_question_mark: ['❔', 'white_question grey_question', 8],
  white_exclamation_mark: ['❕', 'white_exclamation grey_exclamation', 8],
  red_exclamation_mark: ['❗', 'exclamation heavy_exclamation_mark', 8],
  wavy_dash: ['〰', 8],
  currency_exchange: ['💱', 8],
  heavy_dollar_sign: ['💲', 8],
  medical_symbol: ['⚕', 'medical', 8],
  recycling_symbol: ['♻', 'recycle', 8],
  fleur_de_lis: ['⚜', 'fleur-de-lis', 8],
  trident_emblem: ['🔱', 'trident', 8],
  name_badge: ['📛', 8],
  japanese_symbol_for_beginner: ['🔰', 'beginner', 8],
  hollow_red_circle: ['⭕', 'red_o', 8],
  check_mark_button: ['✅', 'white_check_mark', 8],
  check_box_with_check: ['☑', 'ballot_box_with_check', 8],
  check_mark: ['✔', 'heavy_check_mark', 8],
  cross_mark: ['❌', 'x', 8],
  cross_mark_button: ['❎', 'negative_squared_cross_mark', 8],
  curly_loop: ['➰', 8],
  double_curly_loop: ['➿', 'loop', 8],
  part_alternation_mark: ['〽', 8],
  eight_spoked_asterisk: ['✳', 8],
  eight_pointed_star: ['✴', 'eight_pointed_black_star', 8],
  sparkle: ['❇', 8],
  copyright: ['©', 8],
  registered: ['®', 8],
  trade_mark: ['™', 'tm', 8],
  splatter: ['🫟', 8],
  keycap_number_sign: ['#️⃣', 'hash number_sign', 8],
  keycap_asterisk: ['*️⃣', 'asterisk', 8],
  keycap_0: ['0️⃣', 'zero', 8],
  keycap_1: ['1️⃣', 'one', 8],
  keycap_2: ['2️⃣', 'two', 8],
  keycap_3: ['3️⃣', 'three', 8],
  keycap_4: ['4️⃣', 'four', 8],
  keycap_5: ['5️⃣', 'five', 8],
  keycap_6: ['6️⃣', 'six', 8],
  keycap_7: ['7️⃣', 'seven', 8],
  keycap_8: ['8️⃣', 'eight', 8],
  keycap_9: ['9️⃣', 'nine', 8],
  keycap_10: ['🔟', 'ten keycap_ten', 8],
  input_latin_uppercase: ['🔠', 'capital_abcd', 8],
  input_latin_lowercase: ['🔡', 'abcd', 8],
  input_numbers: ['🔢', '1234', 8],
  input_symbols: ['🔣', 'symbols', 8],
  input_latin_letters: ['🔤', 'abc', 8],
  a_button_blood_type: ['🅰', 'a a_blood', 8],
  ab_button_blood_type: ['🆎', 'ab ab_blood', 8],
  b_button_blood_type: ['🅱', 'b b_blood', 8],
  cl_button: ['🆑', 'cl', 8],
  cool_button: ['🆒', 'cool', 8],
  free_button: ['🆓', 'free', 8],
  information: ['ℹ', 'info information_source', 8],
  id_button: ['🆔', 'id', 8],
  circled_m: ['Ⓜ', 'm', 8],
  new_button: ['🆕', 'new', 8],
  ng_button: ['🆖', 'ng', 8],
  o_button_blood_type: ['🅾', 'o o_blood o2', 8],
  ok_button: ['🆗', 'ok', 8],
  p_button: ['🅿', 'parking', 8],
  sos_button: ['🆘', 'sos', 8],
  up_button: ['🆙', 'up2', 8],
  vs_button: ['🆚', 'vs', 8],
  japanese_here_button: ['🈁', 'ja_here koko', 8],
  japanese_service_charge_button: ['🈂', 'ja_service_charge sa', 8],
  japanese_monthly_amount_button: ['🈷', 'ja_monthly_amount', 8],
  japanese_not_free_of_charge_button: ['🈶', 'ja_not_free_of_carge', 8],
  japanese_reserved_button: ['🈯', 'ja_reserved', 8],
  japanese_bargain_button: ['🉐', 'ideograph_advantage ja_bargain', 8],
  japanese_discount_button: ['🈹', 'ja_discount', 8],
  japanese_free_of_charge_button: ['🈚', 'ja_free_of_charge', 8],
  japanese_prohibited_button: ['🈲', 'ja_prohibited', 8],
  japanese_acceptable_button: ['🉑', 'accept ja_acceptable', 8],
  japanese_application_button: ['🈸', 'ja_application', 8],
  japanese_passing_grade_button: ['🈴', 'ja_passing_grade', 8],
  japanese_vacancy_button: ['🈳', 'ja_vacancy', 8],
  japanese_congratulations_button: ['㊗', 'congratulations ja_congratulations', 8],
  japanese_secret_button: ['㊙', 'ja_secret secret', 8],
  japanese_open_for_business_button: ['🈺', 'ja_open_for_business', 8],
  japanese_no_vacancy_button: ['🈵', 'ja_no_vacancy u6e80', 8],
  red_circle: ['🔴', 8],
  orange_circle: ['🟠', 8],
  yellow_circle: ['🟡', 8],
  green_circle: ['🟢', 8],
  blue_circle: ['🔵', 'large_blue_circle', 8],
  purple_circle: ['🟣', 8],
  brown_circle: ['🟤', 8],
  black_circle: ['⚫', 8],
  white_circle: ['⚪', 8],
  red_square: ['🟥', 8],
  orange_square: ['🟧', 8],
  yellow_square: ['🟨', 8],
  green_square: ['🟩', 8],
  blue_square: ['🟦', 8],
  purple_square: ['🟪', 8],
  brown_square: ['🟫', 8],
  black_large_square: ['⬛', 8],
  white_large_square: ['⬜', 8],
  black_medium_square: ['◼', 8],
  white_medium_square: ['◻', 8],
  black_medium_small_square: ['◾', 8],
  white_medium_small_square: ['◽', 8],
  black_small_square: ['▪', 8],
  white_small_square: ['▫', 8],
  large_orange_diamond: ['🔶', 8],
  large_blue_diamond: ['🔷', 8],
  small_orange_diamond: ['🔸', 8],
  small_blue_diamond: ['🔹', 8],
  red_triangle_pointed_up: ['🔺', 'small_red_triangle', 8],
  red_triangle_pointed_down: ['🔻', 'small_red_triangle_down', 8],
  diamond_with_a_dot: ['💠', 'diamond_shape_with_a_dot_inside', 8],
  radio_button: ['🔘', 8],
  white_square_button: ['🔳', 8],
  black_square_button: ['🔲', 8],
  chequered_flag: ['🏁', 'checkered_flag', 9],
  triangular_flag: ['🚩', 'triangular_flag_on_post', 9],
  crossed_flags: ['🎌', 9],
  black_flag: ['🏴', 9],
  white_flag: ['🏳', 9],
  rainbow_flag: ['🏳️‍🌈', 9],
  transgender_flag: ['🏳️‍⚧️', 9],
  pirate_flag: ['🏴‍☠️', 'jolly_roger', 9],
  flag_ascension_island: ['🇦🇨', 'ascension_island flag_ac', 9],
  flag_andorra: ['🇦🇩', 'andorra flag_ad', 9],
  flag_united_arab_emirates: ['🇦🇪', 'flag_ae united_arab_emirates', 9],
  flag_afghanistan: ['🇦🇫', 'afghanistan flag_af', 9],
  flag_antigua_barbuda: ['🇦🇬', 'antigua_barbuda flag_ag', 9],
  flag_anguilla: ['🇦🇮', 'anguilla flag_ai', 9],
  flag_albania: ['🇦🇱', 'albania flag_al', 9],
  flag_armenia: ['🇦🇲', 'armenia flag_am', 9],
  flag_angola: ['🇦🇴', 'angola flag_ao', 9],
  flag_antarctica: ['🇦🇶', 'antarctica flag_aq', 9],
  flag_argentina: ['🇦🇷', 'argentina flag_ar', 9],
  flag_american_samoa: ['🇦🇸', 'american_samoa flag_as', 9],
  flag_austria: ['🇦🇹', 'austria flag_at', 9],
  flag_australia: ['🇦🇺', 'australia flag_au', 9],
  flag_aruba: ['🇦🇼', 'aruba flag_aw', 9],
  flag_aland_islands: ['🇦🇽', 'aland_islands flag_ax', 9],
  flag_azerbaijan: ['🇦🇿', 'azerbaijan flag_az', 9],
  flag_bosnia_herzegovina: ['🇧🇦', 'bosnia_herzegovina flag_ba', 9],
  flag_barbados: ['🇧🇧', 'barbados flag_bb', 9],
  flag_bangladesh: ['🇧🇩', 'bangladesh flag_bd', 9],
  flag_belgium: ['🇧🇪', 'belgium flag_be', 9],
  flag_burkina_faso: ['🇧🇫', 'burkina_faso flag_bf', 9],
  flag_bulgaria: ['🇧🇬', 'bulgaria flag_bg', 9],
  flag_bahrain: ['🇧🇭', 'bahrain flag_bh', 9],
  flag_burundi: ['🇧🇮', 'burundi flag_bi', 9],
  flag_benin: ['🇧🇯', 'benin flag_bj', 9],
  flag_st_barthelemy: ['🇧🇱', 'flag_bl st_barthelemy', 9],
  flag_bermuda: ['🇧🇲', 'bermuda flag_bm', 9],
  flag_brunei: ['🇧🇳', 'brunei flag_bn', 9],
  flag_bolivia: ['🇧🇴', 'bolivia flag_bo', 9],
  flag_caribbean_netherlands: ['🇧🇶', 'caribbean_netherlands flag_bq', 9],
  flag_brazil: ['🇧🇷', 'brazil flag_br', 9],
  flag_bahamas: ['🇧🇸', 'bahamas flag_bs', 9],
  flag_bhutan: ['🇧🇹', 'bhutan flag_bt', 9],
  flag_bouvet_island: ['🇧🇻', 'bouvet_island flag_bv', 9],
  flag_botswana: ['🇧🇼', 'botswana flag_bw', 9],
  flag_belarus: ['🇧🇾', 'belarus flag_by', 9],
  flag_belize: ['🇧🇿', 'belize flag_bz', 9],
  flag_canada: ['🇨🇦', 'canada flag_ca', 9],
  flag_cocos_keeling_islands: ['🇨🇨', 'cocos_islands flag_cc', 9],
  flag_congo_kinshasa: ['🇨🇩', 'congo_kinshasa flag_cd', 9],
  flag_central_african_republic: ['🇨🇫', 'central_african_republic flag_cf', 9],
  flag_congo_brazzaville: ['🇨🇬', 'congo_brazzaville flag_cg', 9],
  flag_switzerland: ['🇨🇭', 'flag_ch switzerland', 9],
  flag_cote_divoire: ['🇨🇮', 'cote_divoire flag_ci', 9],
  flag_cook_islands: ['🇨🇰', 'cook_islands flag_ck', 9],
  flag_chile: ['🇨🇱', 'chile flag_cl', 9],
  flag_cameroon: ['🇨🇲', 'cameroon flag_cm', 9],
  flag_china: ['🇨🇳', 'china flag_cn cn', 9],
  flag_colombia: ['🇨🇴', 'colombia flag_co', 9],
  flag_clipperton_island: ['🇨🇵', 'clipperton_island flag_cp', 9],
  flag_sark: ['🇨🇶', 'flag_cq sark', 9],
  flag_costa_rica: ['🇨🇷', 'costa_rica flag_cr', 9],
  flag_cuba: ['🇨🇺', 'cuba flag_cu', 9],
  flag_cape_verde: ['🇨🇻', 'cape_verde flag_cv', 9],
  flag_curacao: ['🇨🇼', 'curacao flag_cw', 9],
  flag_christmas_island: ['🇨🇽', 'christmas_island flag_cx', 9],
  flag_cyprus: ['🇨🇾', 'cyprus flag_cy', 9],
  flag_czechia: ['🇨🇿', 'czech_republic czechia flag_cz', 9],
  flag_germany: ['🇩🇪', 'flag_de germany de', 9],
  flag_diego_garcia: ['🇩🇬', 'diego_garcia flag_dg', 9],
  flag_djibouti: ['🇩🇯', 'djibouti flag_dj', 9],
  flag_denmark: ['🇩🇰', 'denmark flag_dk', 9],
  flag_dominica: ['🇩🇲', 'dominica flag_dm', 9],
  flag_dominican_republic: ['🇩🇴', 'dominican_republic flag_do', 9],
  flag_algeria: ['🇩🇿', 'algeria flag_dz', 9],
  flag_ceuta_melilla: ['🇪🇦', 'ceuta_melilla flag_ea', 9],
  flag_ecuador: ['🇪🇨', 'ecuador flag_ec', 9],
  flag_estonia: ['🇪🇪', 'estonia flag_ee', 9],
  flag_egypt: ['🇪🇬', 'egypt flag_eg', 9],
  flag_western_sahara: ['🇪🇭', 'flag_eh western_sahara', 9],
  flag_eritrea: ['🇪🇷', 'eritrea flag_er', 9],
  flag_spain: ['🇪🇸', 'flag_es spain es', 9],
  flag_ethiopia: ['🇪🇹', 'ethiopia flag_et', 9],
  flag_european_union: ['🇪🇺', 'european_union flag_eu eu', 9],
  flag_finland: ['🇫🇮', 'finland flag_fi', 9],
  flag_fiji: ['🇫🇯', 'fiji flag_fj', 9],
  flag_falkland_islands: ['🇫🇰', 'falkland_islands flag_fk', 9],
  flag_micronesia: ['🇫🇲', 'flag_fm micronesia', 9],
  flag_faroe_islands: ['🇫🇴', 'faroe_islands flag_fo', 9],
  flag_france: ['🇫🇷', 'flag_fr france fr', 9],
  flag_gabon: ['🇬🇦', 'flag_ga gabon', 9],
  flag_united_kingdom: ['🇬🇧', 'flag_gb uk united_kingdom gb', 9],
  flag_grenada: ['🇬🇩', 'flag_gd grenada', 9],
  flag_georgia: ['🇬🇪', 'flag_ge georgia', 9],
  flag_french_guiana: ['🇬🇫', 'flag_gf french_guiana', 9],
  flag_guernsey: ['🇬🇬', 'flag_gg guernsey', 9],
  flag_ghana: ['🇬🇭', 'flag_gh ghana', 9],
  flag_gibraltar: ['🇬🇮', 'flag_gi gibraltar', 9],
  flag_greenland: ['🇬🇱', 'flag_gl greenland', 9],
  flag_gambia: ['🇬🇲', 'flag_gm gambia', 9],
  flag_guinea: ['🇬🇳', 'flag_gn guinea', 9],
  flag_guadeloupe: ['🇬🇵', 'flag_gp guadeloupe', 9],
  flag_equatorial_guinea: ['🇬🇶', 'equatorial_guinea flag_gq', 9],
  flag_greece: ['🇬🇷', 'flag_gr greece', 9],
  flag_south_georgia_south_sandwich_islands: ['🇬🇸', 'flag_gs south_georgia_south_sandwich_islands', 9],
  flag_guatemala: ['🇬🇹', 'flag_gt guatemala', 9],
  flag_guam: ['🇬🇺', 'flag_gu guam', 9],
  flag_guinea_bissau: ['🇬🇼', 'flag_gw guinea_bissau', 9],
  flag_guyana: ['🇬🇾', 'flag_gy guyana', 9],
  flag_hong_kong_sar_china: ['🇭🇰', 'flag_hk hong_kong', 9],
  flag_heard_mcdonald_islands: ['🇭🇲', 'flag_hm heard_mcdonald_islands', 9],
  flag_honduras: ['🇭🇳', 'flag_hn honduras', 9],
  flag_croatia: ['🇭🇷', 'croatia flag_hr', 9],
  flag_haiti: ['🇭🇹', 'flag_ht haiti', 9],
  flag_hungary: ['🇭🇺', 'flag_hu hungary', 9],
  flag_canary_islands: ['🇮🇨', 'canary_islands flag_ic', 9],
  flag_indonesia: ['🇮🇩', 'flag_id indonesia', 9],
  flag_ireland: ['🇮🇪', 'flag_ie ireland', 9],
  flag_israel: ['🇮🇱', 'flag_il israel', 9],
  flag_isle_of_man: ['🇮🇲', 'flag_im isle_of_man', 9],
  flag_india: ['🇮🇳', 'flag_in india', 9],
  flag_british_indian_ocean_territory: ['🇮🇴', 'british_indian_ocean_territory flag_io', 9],
  flag_iraq: ['🇮🇶', 'flag_iq iraq', 9],
  flag_iran: ['🇮🇷', 'flag_ir iran', 9],
  flag_iceland: ['🇮🇸', 'flag_is iceland', 9],
  flag_italy: ['🇮🇹', 'flag_it italy it', 9],
  flag_jersey: ['🇯🇪', 'flag_je jersey', 9],
  flag_jamaica: ['🇯🇲', 'flag_jm jamaica', 9],
  flag_jordan: ['🇯🇴', 'flag_jo jordan', 9],
  flag_japan: ['🇯🇵', 'flag_jp japan jp', 9],
  flag_kenya: ['🇰🇪', 'flag_ke kenya', 9],
  flag_kyrgyzstan: ['🇰🇬', 'flag_kg kyrgyzstan', 9],
  flag_cambodia: ['🇰🇭', 'cambodia flag_kh', 9],
  flag_kiribati: ['🇰🇮', 'flag_ki kiribati', 9],
  flag_comoros: ['🇰🇲', 'comoros flag_km', 9],
  flag_st_kitts_nevis: ['🇰🇳', 'flag_kn st_kitts_nevis', 9],
  flag_north_korea: ['🇰🇵', 'flag_kp north_korea', 9],
  flag_south_korea: ['🇰🇷', 'flag_kr south_korea kr', 9],
  flag_kuwait: ['🇰🇼', 'flag_kw kuwait', 9],
  flag_cayman_islands: ['🇰🇾', 'cayman_islands flag_ky', 9],
  flag_kazakhstan: ['🇰🇿', 'flag_kz kazakhstan', 9],
  flag_laos: ['🇱🇦', 'flag_la laos', 9],
  flag_lebanon: ['🇱🇧', 'flag_lb lebanon', 9],
  flag_st_lucia: ['🇱🇨', 'flag_lc st_lucia', 9],
  flag_liechtenstein: ['🇱🇮', 'flag_li liechtenstein', 9],
  flag_sri_lanka: ['🇱🇰', 'flag_lk sri_lanka', 9],
  flag_liberia: ['🇱🇷', 'flag_lr liberia', 9],
  flag_lesotho: ['🇱🇸', 'flag_ls lesotho', 9],
  flag_lithuania: ['🇱🇹', 'flag_lt lithuania', 9],
  flag_luxembourg: ['🇱🇺', 'flag_lu luxembourg', 9],
  flag_latvia: ['🇱🇻', 'flag_lv latvia', 9],
  flag_libya: ['🇱🇾', 'flag_ly libya', 9],
  flag_morocco: ['🇲🇦', 'flag_ma morocco', 9],
  flag_monaco: ['🇲🇨', 'flag_mc monaco', 9],
  flag_moldova: ['🇲🇩', 'flag_md moldova', 9],
  flag_montenegro: ['🇲🇪', 'flag_me montenegro', 9],
  flag_st_martin: ['🇲🇫', 'flag_mf st_martin', 9],
  flag_madagascar: ['🇲🇬', 'flag_mg madagascar', 9],
  flag_marshall_islands: ['🇲🇭', 'flag_mh marshall_islands', 9],
  flag_north_macedonia: ['🇲🇰', 'flag_mk macedonia', 9],
  flag_mali: ['🇲🇱', 'flag_ml mali', 9],
  flag_myanmar_burma: ['🇲🇲', 'burma flag_mm myanmar', 9],
  flag_mongolia: ['🇲🇳', 'flag_mn mongolia', 9],
  flag_macao_sar_china: ['🇲🇴', 'flag_mo macao macau', 9],
  flag_northern_mariana_islands: ['🇲🇵', 'flag_mp northern_mariana_islands', 9],
  flag_martinique: ['🇲🇶', 'flag_mq martinique', 9],
  flag_mauritania: ['🇲🇷', 'flag_mr mauritania', 9],
  flag_montserrat: ['🇲🇸', 'flag_ms montserrat', 9],
  flag_malta: ['🇲🇹', 'flag_mt malta', 9],
  flag_mauritius: ['🇲🇺', 'flag_mu mauritius', 9],
  flag_maldives: ['🇲🇻', 'flag_mv maldives', 9],
  flag_malawi: ['🇲🇼', 'flag_mw malawi', 9],
  flag_mexico: ['🇲🇽', 'flag_mx mexico', 9],
  flag_malaysia: ['🇲🇾', 'flag_my malaysia', 9],
  flag_mozambique: ['🇲🇿', 'flag_mz mozambique', 9],
  flag_namibia: ['🇳🇦', 'flag_na namibia', 9],
  flag_new_caledonia: ['🇳🇨', 'flag_nc new_caledonia', 9],
  flag_niger: ['🇳🇪', 'flag_ne niger', 9],
  flag_norfolk_island: ['🇳🇫', 'flag_nf norfolk_island', 9],
  flag_nigeria: ['🇳🇬', 'flag_ng nigeria', 9],
  flag_nicaragua: ['🇳🇮', 'flag_ni nicaragua', 9],
  flag_netherlands: ['🇳🇱', 'flag_nl netherlands', 9],
  flag_norway: ['🇳🇴', 'flag_no norway', 9],
  flag_nepal: ['🇳🇵', 'flag_np nepal', 9],
  flag_nauru: ['🇳🇷', 'flag_nr nauru', 9],
  flag_niue: ['🇳🇺', 'flag_nu niue', 9],
  flag_new_zealand: ['🇳🇿', 'flag_nz new_zealand', 9],
  flag_oman: ['🇴🇲', 'flag_om oman', 9],
  flag_panama: ['🇵🇦', 'flag_pa panama', 9],
  flag_peru: ['🇵🇪', 'flag_pe peru', 9],
  flag_french_polynesia: ['🇵🇫', 'flag_pf french_polynesia', 9],
  flag_papua_new_guinea: ['🇵🇬', 'flag_pg papua_new_guinea', 9],
  flag_philippines: ['🇵🇭', 'flag_ph philippines', 9],
  flag_pakistan: ['🇵🇰', 'flag_pk pakistan', 9],
  flag_poland: ['🇵🇱', 'flag_pl poland', 9],
  flag_st_pierre_miquelon: ['🇵🇲', 'flag_pm st_pierre_miquelon', 9],
  flag_pitcairn_islands: ['🇵🇳', 'flag_pn pitcairn_islands', 9],
  flag_puerto_rico: ['🇵🇷', 'flag_pr puerto_rico', 9],
  flag_palestinian_territories: ['🇵🇸', 'flag_ps palestinian_territories', 9],
  flag_portugal: ['🇵🇹', 'flag_pt portugal', 9],
  flag_palau: ['🇵🇼', 'flag_pw palau', 9],
  flag_paraguay: ['🇵🇾', 'flag_py paraguay', 9],
  flag_qatar: ['🇶🇦', 'flag_qa qatar', 9],
  flag_reunion: ['🇷🇪', 'flag_re reunion', 9],
  flag_romania: ['🇷🇴', 'flag_ro romania', 9],
  flag_serbia: ['🇷🇸', 'flag_rs serbia', 9],
  flag_russia: ['🇷🇺', 'flag_ru russia ru', 9],
  flag_rwanda: ['🇷🇼', 'flag_rw rwanda', 9],
  flag_saudi_arabia: ['🇸🇦', 'flag_sa saudi_arabia', 9],
  flag_solomon_islands: ['🇸🇧', 'flag_sb solomon_islands', 9],
  flag_seychelles: ['🇸🇨', 'flag_sc seychelles', 9],
  flag_sudan: ['🇸🇩', 'flag_sd sudan', 9],
  flag_sweden: ['🇸🇪', 'flag_se sweden', 9],
  flag_singapore: ['🇸🇬', 'flag_sg singapore', 9],
  flag_st_helena: ['🇸🇭', 'flag_sh st_helena', 9],
  flag_slovenia: ['🇸🇮', 'flag_si slovenia', 9],
  flag_svalbard_jan_mayen: ['🇸🇯', 'flag_sj svalbard_jan_mayen', 9],
  flag_slovakia: ['🇸🇰', 'flag_sk slovakia', 9],
  flag_sierra_leone: ['🇸🇱', 'flag_sl sierra_leone', 9],
  flag_san_marino: ['🇸🇲', 'flag_sm san_marino', 9],
  flag_senegal: ['🇸🇳', 'flag_sn senegal', 9],
  flag_somalia: ['🇸🇴', 'flag_so somalia', 9],
  flag_suriname: ['🇸🇷', 'flag_sr suriname', 9],
  flag_south_sudan: ['🇸🇸', 'flag_ss south_sudan', 9],
  flag_sao_tome_principe: ['🇸🇹', 'flag_st sao_tome_principe', 9],
  flag_el_salvador: ['🇸🇻', 'el_salvador flag_sv', 9],
  flag_sint_maarten: ['🇸🇽', 'flag_sx sint_maarten', 9],
  flag_syria: ['🇸🇾', 'flag_sy syria', 9],
  flag_eswatini: ['🇸🇿', 'eswatini flag_sz swaziland', 9],
  flag_tristan_da_cunha: ['🇹🇦', 'flag_ta tristan_da_cunha', 9],
  flag_turks_caicos_islands: ['🇹🇨', 'flag_tc turks_caicos_islands', 9],
  flag_chad: ['🇹🇩', 'chad flag_td', 9],
  flag_french_southern_territories: ['🇹🇫', 'flag_tf french_southern_territories', 9],
  flag_togo: ['🇹🇬', 'flag_tg togo', 9],
  flag_thailand: ['🇹🇭', 'flag_th thailand', 9],
  flag_tajikistan: ['🇹🇯', 'flag_tj tajikistan', 9],
  flag_tokelau: ['🇹🇰', 'flag_tk tokelau', 9],
  flag_timor_leste: ['🇹🇱', 'flag_tl timor_leste', 9],
  flag_turkmenistan: ['🇹🇲', 'flag_tm turkmenistan', 9],
  flag_tunisia: ['🇹🇳', 'flag_tn tunisia', 9],
  flag_tonga: ['🇹🇴', 'flag_to tonga', 9],
  flag_turkiye: ['🇹🇷', 'flag_tr turkey_tr tr', 9],
  flag_trinidad_tobago: ['🇹🇹', 'flag_tt trinidad_tobago', 9],
  flag_tuvalu: ['🇹🇻', 'flag_tv tuvalu', 9],
  flag_taiwan: ['🇹🇼', 'flag_tw taiwan', 9],
  flag_tanzania: ['🇹🇿', 'flag_tz tanzania', 9],
  flag_ukraine: ['🇺🇦', 'flag_ua ukraine', 9],
  flag_uganda: ['🇺🇬', 'flag_ug uganda', 9],
  flag_us_outlying_islands: ['🇺🇲', 'flag_um us_outlying_islands', 9],
  flag_united_nations: ['🇺🇳', 'flag_un un united_nations', 9],
  flag_united_states: ['🇺🇸', 'flag_us united_states usa us', 9],
  flag_uruguay: ['🇺🇾', 'flag_uy uruguay', 9],
  flag_uzbekistan: ['🇺🇿', 'flag_uz uzbekistan', 9],
  flag_vatican_city: ['🇻🇦', 'flag_va vatican_city', 9],
  flag_st_vincent_grenadines: ['🇻🇨', 'flag_vc st_vincent_grenadines', 9],
  flag_venezuela: ['🇻🇪', 'flag_ve venezuela', 9],
  flag_british_virgin_islands: ['🇻🇬', 'british_virgin_islands flag_vg', 9],
  flag_us_virgin_islands: ['🇻🇮', 'flag_vi us_virgin_islands', 9],
  flag_vietnam: ['🇻🇳', 'flag_vn vietnam', 9],
  flag_vanuatu: ['🇻🇺', 'flag_vu vanuatu', 9],
  flag_wallis_futuna: ['🇼🇫', 'flag_wf wallis_futuna', 9],
  flag_samoa: ['🇼🇸', 'flag_ws samoa', 9],
  flag_kosovo: ['🇽🇰', 'flag_xk kosovo', 9],
  flag_yemen: ['🇾🇪', 'flag_ye yemen', 9],
  flag_mayotte: ['🇾🇹', 'flag_yt mayotte', 9],
  flag_south_africa: ['🇿🇦', 'flag_za south_africa', 9],
  flag_zambia: ['🇿🇲', 'flag_zm zambia', 9],
  flag_zimbabwe: ['🇿🇼', 'flag_zw zimbabwe', 9],
  flag_england: ['🏴󠁧󠁢󠁥󠁮󠁧󠁿', 'england flag_gbeng', 9],
  flag_scotland: ['🏴󠁧󠁢󠁳󠁣󠁴󠁿', 'flag_gbsct scotland', 9],
  flag_wales: ['🏴󠁧󠁢󠁷󠁬󠁳󠁿', 'flag_gbwls wales', 9],
}

export const emojiGroupData = [
  {
    key: 'smileys-emotion',
    message: 'smileys & emotion',
    order: 0,
    emojis: [],
  },
  {
    key: 'people-body',
    message: 'people & body',
    order: 1,
    emojis: [],
  },
  {
    key: 'component',
    message: 'components',
    order: 2,
    emojis: [],
  },
  {
    key: 'animals-nature',
    message: 'animals & nature',
    order: 3,
    emojis: [],
  },
  {
    key: 'food-drink',
    message: 'food & drink',
    order: 4,
    emojis: [],
  },
  {
    key: 'travel-places',
    message: 'travel & places',
    order: 5,
    emojis: [],
  },
  {
    key: 'activities',
    message: 'activities',
    order: 6,
    emojis: [],
  },
  {
    key: 'objects',
    message: 'objects',
    order: 7,
    emojis: [],
  },
  {
    key: 'symbols',
    message: 'symbols',
    order: 8,
    emojis: [],
  },
  {
    key: 'flags',
    message: 'flags',
    order: 9,
    emojis: [],
  },
]
